import React, { useState, useMemo, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import CustomTable from "../../common/CustomTable";
import {
  Select,
  DatePicker,
  Spin,
  message,
  Button,
  Dropdown,
  Space,
} from "antd";
import { Timesheetapi } from "../../../middleware/interceptor";
import dayjs from "dayjs";
import * as moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import CryptoJS from "crypto-js";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { DownOutlined, CheckOutlined } from "@ant-design/icons";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { Employee_report } from "./Employee_report";
import isoWeek from "dayjs/plugin/isoWeek";
import BarChartIcon from "@mui/icons-material/BarChart";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

const { Option } = Select;
const { RangePicker } = DatePicker;

export default function ProjectReport({ Secret_key, sidebor }) {
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
  
  const [searchParams] = useSearchParams();
  
  //initial data
  const [rawData, setRawData] = useState([]);
  //initial data end

  const [selectedTimePeriod, setSelectedTimePeriod] = useState("week");
  const [loading, setloading] = useState(true);
  const [selectedDates, setSelectedDates] = useState([]);
  const [sDate, setSdate] = useState();
  const [eDate, setEdate] = useState();

  const [selectedWeekDates, setSelectedWeekDates] = useState([]);
  const [dateList, setDateList] = useState([]);
  const today = dayjs().utc().toDate();

  //For Project Report
  const [allClientList, setAllClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState();
  const [selectedType, setSelectedType] = useState(1);
  const [selectedClientDetails, setSelectedClientDetails] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [totalHours, setTotalHours] = useState();
  const [offHours, setOffHours] = useState(0);
  const [clientChanged, setClientChanged] = useState(false);
  const [selectedProject, setSelectedProject] = useState();
  const [selectedProjectName, setSelectedProjectName] = useState();
  const [projectDisabled, setProjectDisabled] = useState();
  // const [taskDisabled, setTaskDisabled] = useState();
  const [projectList, setProjectList] = useState([]);
  const [Employee, setEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedGrouping, setSelectedGrouping] = useState("None");
  const [selectedTask, setSelectedTask] = useState("All");
  const [TaskList, setTaskList] = useState([{ label: "All", value: "All" }]);
  const [summaryHours, setSummaryHours] = useState({
    total: 0,
    working: 0,
    billing: 0,
    nonBilling: 0,
    empbillingPercentage: "0.00%",
    empnonBillingPercentage: "0.00%",
    emptotalPercentage: "0.00%",
  });
  const [projectSummary, setProjectSummary] = useState({
    totalHours: "0.00",
    billingHours: "0.00",
    nonBillingHours: "0.00",
    estimatedHours: "0.00",
    billingPercentage: "0.00%",
    nonBillingPercentage: "0.00%",
    totalPercentage: "0.00%",
  });

  // Handle URL parameters to pre-select project and client
  const [urlProjectId, setUrlProjectId] = useState(null);
  const [urlProjectName, setUrlProjectName] = useState(null);
  const [urlClientName, setUrlClientName] = useState(null);
  const [urlClientId, setUrlClientId] = useState(null);
  const [urlStartDate, setUrlStartDate] = useState(null);
  const [urlEndDate, setUrlEndDate] = useState(null);
  const [urlTimePeriod, setUrlTimePeriod] = useState(null);
  const [clientWiseTHrs,setClientWiseTHrs] = useState(null);

  useEffect(() => {
    const projectIdParam = searchParams.get('project');
    const projectNameParam = searchParams.get('projectName');
    const clientNameParam = searchParams.get('client');
    const clientIdParam = searchParams.get('clientId');
    const startDateParam = searchParams.get('startDate');
    const endDateParam = searchParams.get('endDate');
    const timePeriodParam = searchParams.get('timePeriod');
    
    if (projectIdParam) {
      setUrlProjectId(projectIdParam);
    }
    if (projectNameParam) {
      setUrlProjectName(decodeURIComponent(projectNameParam));
    }
    if (clientNameParam) {
      setUrlClientName(clientNameParam);
    }
    if (clientIdParam) {
      setUrlClientId(decodeURIComponent(clientIdParam));
    }
    if (startDateParam) {
      setUrlStartDate(decodeURIComponent(startDateParam));
    }
    if (endDateParam) {
      setUrlEndDate(decodeURIComponent(endDateParam));
    }
    if (timePeriodParam) {
      setUrlTimePeriod(decodeURIComponent(timePeriodParam));
    }
  }, [searchParams]);

  // Set client when URL parameters are available
  useEffect(() => {
    if (urlClientName && allClientList.length > 0) {
      const matchingClient = allClientList.find(
        (c) => {
          const matches = c.label && c.label.toLowerCase() === urlClientName.toLowerCase();
          if (matches) {
            console.log("Matching client found:", c.label, "->", c.value);
          }
          return matches;
        }
      );
      
      if (matchingClient && selectedClient !== matchingClient.value) {
        console.log("Setting selected client from URL:", matchingClient.value);
        setSelectedClient(matchingClient.value);
      }
    }
  }, [urlClientName, allClientList]);

  // Set project after projects are loaded for the selected client
  useEffect(() => {
    if (urlProjectId && projectList && selectedClient) {
      console.log("Attempting to set project from URL");
      console.log("urlProjectId:", urlProjectId, "type:", typeof urlProjectId);
      console.log("selectedClient:", selectedClient, "type:", typeof selectedClient);
      console.log("projectList keys:", Object.keys(projectList));
      console.log("projectList[selectedClient]:", projectList[selectedClient]);
      
      // First try to use urlClientId for direct lookup
      let clientProjects = [];
      if (urlClientId && projectList[urlClientId]) {
        console.log("Using urlClientId for direct lookup:", urlClientId);
        clientProjects = projectList[urlClientId];
      } else {
        clientProjects = projectList[selectedClient] || [];
      }
      
      const projectExists = clientProjects.some(
        (p) => String(p.projectId) === String(urlProjectId)
      );
      
      console.log("Project exists in list:", projectExists);
      
      if (projectExists && String(selectedProject) !== String(urlProjectId)) {
        console.log("Setting project from URL:", urlProjectId);
        setSelectedProject(String(urlProjectId));
        
        // Find and set the actual project name from the loaded data
        const matchingProject = clientProjects.find(
          (p) => String(p.projectId) === String(urlProjectId)
        );
        
        if (matchingProject && matchingProject.projectName) {
          console.log("Setting project name from loaded data:", matchingProject.projectName);
          setSelectedProjectName(matchingProject.projectName);
        } else if (urlProjectName) {
          // Fallback to URL parameter if not found in list
          setSelectedProjectName(urlProjectName);
        }
      }
    }
  }, [urlProjectId, urlProjectName, urlClientId, projectList, selectedClient]);

  // Extract actual project name if URL contains Project-{id} format, or match it from projectList
  useEffect(() => {
    if (urlProjectName && urlProjectId && projectList) {
      // Check if projectName is in the format "Project-{id}" or is just a number (likely an ID)
      if (/^Project-\d+$/.test(urlProjectName) || /^\d+$/.test(urlProjectName)) {
        console.log("Project name appears to be an ID or placeholder, looking up actual name");
        // Find the actual project name from projectList
        let clientProjects = [];
        
        // Try using urlClientId first
        if (urlClientId && projectList[urlClientId]) {
          clientProjects = projectList[urlClientId];
        }
        // Then try selectedClient
        else if (selectedClient && projectList[selectedClient]) {
          clientProjects = projectList[selectedClient];
        }
        // Finally, search all clients
        else {
          for (const clientKey in projectList) {
            const projects = projectList[clientKey];
            const found = projects.find((p) => String(p.projectId) === String(urlProjectId));
            if (found) {
              clientProjects = projects;
              break;
            }
          }
        }
        
        const matchingProject = clientProjects.find(
          (p) => String(p.projectId) === String(urlProjectId)
        );
        
        if (matchingProject && matchingProject.projectName) {
          console.log("Found actual project name:", matchingProject.projectName);
          setSelectedProjectName(matchingProject.projectName);
        }
      }
    }
  }, [urlProjectId, urlProjectName, urlClientId, projectList, selectedClient]);

  // Sync project name from projectList whenever selected project or projectList changes
  useEffect(() => {
    if (selectedProject && selectedProject !== "All" && selectedClient && projectList[selectedClient]) {
      const project = projectList[selectedClient].find(
        (p) => String(p.projectId) === String(selectedProject)
      );
      if (project && selectedProjectName !== project.projectName) {
        setSelectedProjectName(project.projectName);
      }
    }
  }, [selectedProject, selectedClient, projectList]);

  // Set dates from URL parameters if available
  useEffect(() => {
    if (urlStartDate && urlEndDate && urlTimePeriod) {
      console.log("Setting dates from URL - Start:", urlStartDate, "End:", urlEndDate, "Period:", urlTimePeriod);
      
      const startDate = dayjs(urlStartDate);
      const endDate = dayjs(urlEndDate);
      
      if (startDate.isValid() && endDate.isValid()) {
        setSelectedDates([startDate, endDate]);
        setSdate(urlStartDate);
        setEdate(urlEndDate);
        setSelectedTimePeriod(urlTimePeriod);
      }
    }
  }, [urlStartDate, urlEndDate, urlTimePeriod]);

  useEffect(() => {
    console.log("Total Hours updated:", totalHours);
  }, [totalHours]);

  const calculateEstimatedHoursBreakdown = (projectId) => {
    if (projectId === "All" || !rawData)
      return { total: 0, billing: 0, nonBilling: 0 };

    const project = rawData.find(
      (p) => String(p.Project_id) === String(projectId)
    );
    if (!project || !project.Tasks || !Array.isArray(project.Tasks)) {
      return { total: 0, billing: 0, nonBilling: 0 };
    }

    // Get unique tasks by ItemId to avoid duplicates
    const uniqueTasks = [
      ...new Map(project.Tasks.map((t) => [t.ItemId, t])).values(),
    ];

    let billingPlanned = 0;
    let nonBillingPlanned = 0;

    uniqueTasks.forEach((task) => {
      const planned = parseFloat(task.Planned_Hours) || 0;
      const taskName = (task.ItemName || "").toLowerCase();

      // if (
      //   taskName.includes("non billable") ||
      //   taskName.includes("non - billable") ||
      //   taskName.includes("bench") ||
      //   (taskName.includes("infra") &&
      //     project.client_name === "RCK Techiees") ||
      //   taskName.includes("training and certification") ||
      //   (project.project_name || "")
      //     .toLowerCase()
      //     .includes("rck market place app") ||
      //   (project.project_name || "")
      //     .toLowerCase()
      //     .includes("freshwork market app")
      // ) 
      if (task.Billing_Status == 0) 
      {
        nonBillingPlanned += planned;
      } else {
        billingPlanned += planned;
      }
    });

    const total = billingPlanned + nonBillingPlanned;

    return {
      total: total.toFixed(2),
      billing: billingPlanned.toFixed(2),
      nonBilling: nonBillingPlanned.toFixed(2),
    };
  };

  useEffect(() => {
    if (selectedProject === "All") {
      setProjectSummary({
        totalHours: "0.00",
        billingHours: "0.00",
        nonBillingHours: "0.00",
        estimatedHours: "0.00",
        billingPlanned: "0.00",
        nonBillingPlanned: "0.00",
        availableHours: "0.00",
        billingPercentage: "0.00%",
        nonBillingPercentage: "0.00%",
        totalPercentage: "0.00%",
      });
      return;
    }

    let totalLogged = 0;
    let billingLogged = 0;
    let nonBillingLogged = 0;

    projectData.forEach((item) => {
      const hrs = parseFloat(item.Hours) || 0;
      totalLogged += hrs;

      // if (
      //   item.task_name?.toLowerCase().includes("non billable") ||
      //   item.task_name?.toLowerCase().includes("bench") ||
      //   item.task_name?.toLowerCase().includes("non - billable") ||
      //   (item.task_name?.toLowerCase().includes("infra") &&
      //     item.client_name === "RCK Techiees") ||
      //   item.task_name?.toLowerCase().includes("training and certification") ||
      //   item.project_name?.toLowerCase().includes("rck market place app") ||
      //   item.project_name?.toLowerCase().includes("freshwork market app")
      // ) 
      if (item.Billing_Status == 0) 
      {
        nonBillingLogged += hrs;
      } else {
        billingLogged += hrs;
      }
    });

    const estimatedBreakdown =
      calculateEstimatedHoursBreakdown(selectedProject);
    const available = (estimatedBreakdown.total - totalLogged).toFixed(2);

    const billingProgress =
      estimatedBreakdown.total > 0
        ? (billingLogged / estimatedBreakdown.total) * 100
        : 0;
    const billingPercentage =
      billingLogged <= estimatedBreakdown.total
        ? billingProgress.toFixed(2) + "%"
        : `-${(billingProgress - 100).toFixed(2)}%`;

    const nonBillingPercentage =
      estimatedBreakdown.total > 0
        ? ((nonBillingLogged / estimatedBreakdown.total) * 100).toFixed(2) + "%"
        : "0.00%";

    const totalProgress =
      estimatedBreakdown.total > 0
        ? (totalLogged / estimatedBreakdown.total) * 100
        : 0;
    const totalPercentage =
      totalLogged <= estimatedBreakdown.total
        ? totalProgress.toFixed(2) + "%"
        : `-${(totalProgress - 100).toFixed(2)}%`;

    setProjectSummary({
      totalHours: totalLogged.toFixed(2),
      billingHours: billingLogged.toFixed(2),
      nonBillingHours: nonBillingLogged.toFixed(2),
      estimatedHours: estimatedBreakdown.total,
      billingPlanned: estimatedBreakdown.billing,
      nonBillingPlanned: estimatedBreakdown.nonBilling,
      availableHours: available,
      billingPercentage,
      nonBillingPercentage,
      totalPercentage,
    });
  }, [projectData, selectedProject, selectedEmployee, rawData]);

  //To find projectList
  useEffect(() => {
    console.log("selectedClient:", selectedClient);
    console.log(
      "Spread data (projectList[selectedClient]):",
      projectList?.[selectedClient]
    );
  }, [selectedClient, projectList]);

  // Populate TaskList from rawData
  useEffect(() => {
    if (rawData && rawData.length > 0) {
      // Flatten all tasks from all projects
      const tasks = rawData
        .flatMap((project) => project.Tasks || [])
        .map((task) => ({ label: task.ItemName, value: task.ItemId }));
      // Remove duplicates
      const uniqueTasks = Array.from(
        new Map(tasks.map((t) => [t.value, t])).values()
      );
      setTaskList([{ label: "All", value: "All" }, ...uniqueTasks]);
    } else {
      setTaskList([{ label: "All", value: "All" }]);
    }
  }, [rawData]);

  useEffect(() => {
    if (selectedProject === "All") {
      setProjectSummary({
        totalHours: "0.00",
        billingHours: "0.00",
        nonBillingHours: "0.00",
        estimatedHours: "0.00",
        availableHours: "0.00",
        billingPercentage: "0.00%",
        nonBillingPercentage: "0.00%",
        totalPercentage: "0.00%",
      });
      return;
    }

    // Logged hours in the current filtered data (projectData already filtered by time period)
    let totalLogged = 0;
    let billingLogged = 0;
    let nonBillingLogged = 0;

    projectData.forEach((item) => {
      const hrs = parseFloat(item.Hours) || 0;
      totalLogged += hrs;

      // if (
      //   item.task_name?.toLowerCase().includes("non billable") ||
      //   item.task_name?.toLowerCase().includes("bench") ||
      //   item.task_name?.toLowerCase().includes("non - billable") ||
      //   (item.task_name?.toLowerCase().includes("infra") &&
      //     item.client_name === "RCK Techiees") ||
      //   item.task_name?.toLowerCase().includes("training and certification") ||
      //   item.project_name?.toLowerCase().includes("rck market place app") ||
      //   item.project_name?.toLowerCase().includes("freshwork market app")
      // ) 
      if (item.Billing_Status == 0) 
      {
        nonBillingLogged += hrs;
      } else {
        billingLogged += hrs;
      }
    });

    // Total estimated hours for the project (from rawData - full plan)
    const client = allClientList.find((c) => c.value === selectedClient);
    const clientAssigned = client ? parseFloat(client.assigned_hours) || 0 : 0;
    const baseEstimated =
      clientAssigned > 0
        ? clientAssigned
        : calculateTotalEstimatedHoursForProject(selectedProject);
    const totalEstimated =
      baseEstimated *
      getPeriodFactor(client?.hours_type === "month" ? "month" : "year");

    // Remaining = Estimated - Logged in current period
    const available = (totalEstimated - totalLogged).toFixed(2);

    // Billing %: positive if under/over ≤100%, negative if over
    const billingProgress =
      totalEstimated > 0 ? (billingLogged / totalEstimated) * 100 : 0;
    const billingPercentage =
      billingLogged <= totalEstimated
        ? billingProgress.toFixed(2) + "%"
        : `-${(billingProgress - 100).toFixed(2)}%`;

    // Non-Billing %: always positive
    const nonBillingPercentage =
      totalEstimated > 0
        ? ((nonBillingLogged / totalEstimated) * 100).toFixed(2) + "%"
        : "0.00%";

    // Total %: positive if under/over ≤100%, negative if over
    const totalProgress =
      totalEstimated > 0 ? (totalLogged / totalEstimated) * 100 : 0;
    const totalPercentage =
      totalLogged <= totalEstimated
        ? totalProgress.toFixed(2) + "%"
        : `-${(totalProgress - 100).toFixed(2)}%`;

    setProjectSummary({
      totalHours: totalLogged.toFixed(2),
      billingHours: billingLogged.toFixed(2),
      nonBillingHours: nonBillingLogged.toFixed(2),
      estimatedHours: totalEstimated.toFixed(2),
      availableHours: available, // Now correct for Day/Week/Month/Year
      billingPercentage,
      nonBillingPercentage,
      totalPercentage,
    });
  }, [
    projectData,
    selectedProject,
    selectedEmployee,
    rawData,
    selectedTimePeriod,
    allClientList,
    sDate,
    eDate,
  ]); // Added selectedTimePeriod

  const calculateTotalEstimatedHoursForProject = (projectId) => {
    if (!rawData || rawData.length === 0 || projectId === "All") return 0;

    console.log("Selected Project ID:", projectId, typeof projectId);

    const projectIdStr = String(projectId);
    const project = rawData.find((p) => String(p.Project_id) === projectIdStr);

    if (!project) {
      console.log("Project not found for ID:", projectIdStr);
      return 0;
    }

    console.log("Found Project:", project.Project_name, project.Project_id);

    if (!project.Tasks || !Array.isArray(project.Tasks)) {
      console.log("No tasks found for:", project.Project_name);
      return 0;
    }

    // Get unique tasks by ItemId (removes duplicates)
    const uniqueTasks = [
      ...new Map(project.Tasks.map((t) => [t.ItemId, t])).values(),
    ];

    console.log("Total tasks:", project.Tasks.length);
    console.log("Unique tasks:", uniqueTasks.length);
    console.log(
      "Unique task names:",
      uniqueTasks.map((t) => t.ItemName)
    );

    // Sum Planned_Hours from unique tasks only
    const totalEstimated = uniqueTasks.reduce((sum, task) => {
      const planned = parseFloat(task.Planned_Hours) || 0;
      return sum + planned;
    }, 0);

    console.log("Total Estimated Hours:", totalEstimated);

    return totalEstimated;
  };

  // Converts a stored monthly or yearly allocation to the selected period.
  const getPeriodFactor = (basis = "year") => {
    const s = dayjs(sDate);
    const e = dayjs(eDate);
    if (!s.isValid() || !e.isValid()) return 1;

    const monthsInRange = {
      year: (e.diff(s, "year") + 1) * 12,
      month: e.diff(s, "month") + 1,
      week: ((e.diff(s, "week") + 1) * 12) / 52,
      day: ((e.diff(s, "day") + 1) * 12) / 365,
    }[selectedTimePeriod];

    if (monthsInRange == null) return 1;

    return basis === "month" ? monthsInRange : monthsInRange / 12;
  };

  const getWorkingHours = (startDate, endDate) => {
    let count = 0;
    let current = new Date(startDate);

    while (current <= endDate) {
      const day = current.getDay();
      if (day !== 0 && day !== 6) count++;
      current.setDate(current.getDate() + 1);
    }
    return count * 8;
  };

  const getWorkedHoursInPeriod = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedTimePeriod === "day") {
      const day = today.getDay();
      return day !== 0 && day !== 6 ? 8 : 0;
    }

    if (selectedTimePeriod === "week") {
      // Start of current week (Monday)
      const startOfWeek = new Date(today);
      const dayOfWeek = today.getDay() === 0 ? 7 : today.getDay();
      startOfWeek.setDate(today.getDate() - (dayOfWeek - 1));

      // End of week (Sunday), but we only count from Monday to today
      // So: from startOfWeek to today
      return getWorkingHours(startOfWeek, today);
    }

    if (selectedTimePeriod === "month") {
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      return getWorkingHours(startOfMonth, today);
    }

    if (selectedTimePeriod === "year") {
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      return getWorkingHours(startOfYear, today);
    }

    return 0;
  };

  useEffect(() => {
    if (selectedEmployee === 1 || !projectData || projectData.length === 0) {
      setSummaryHours({
        total: 0,
        working: 0,
        billing: 0,
        nonBilling: 0,
        billingPercentage: "0.00%",
        nonBillingPercentage: "0.00%",
        totalPercentage: "0.00%",
      });
      return;
    }

    let total = 0;
    let billing = 0;
    let nonBilling = 0;
    let offHours = 0;

    projectData.forEach((item) => {
      const hrs = parseFloat(item.Hours) || 0;

      if (item.task_name?.toLowerCase() === "leave") {
        offHours += hrs;
      } else {
        total += hrs;
        // if (
        //   item.task_name?.toLowerCase().includes("non billable") ||
        //   item.task_name?.toLowerCase().includes("bench") ||
        //   item.task_name?.toLowerCase().includes("non - billable") ||
        //   (item.task_name?.toLowerCase().includes("infra") &&
        //     item.client_name === "RCK Techiees") ||
        //   item.task_name
        //     ?.toLowerCase()
        //     .includes("training and certification") ||
        //   item.project_name?.toLowerCase().includes("rck market place app") ||
        //   item.project_name?.toLowerCase().includes("freshwork market app")
        // ) 
        if (item.Billing_Status == 0)        
        {
          nonBilling += hrs;
        } else {
          billing += hrs;
        }
      }
    });

    // Get hours from start of period to today
    let working = getWorkedHoursInPeriod();

    // Subtract leave hours from available working hours
    working -= offHours;
    working = Math.max(0, working); // Ensure not negative

    const billingProgress = working > 0 ? (billing / working) * 100 : 0;
    const billingPercentage =
      billing <= working
        ? billingProgress.toFixed(2) + "%"
        : `-${(billingProgress - 100).toFixed(2)}%`;

    const nonBillingProgress = working > 0 ? (nonBilling / working) * 100 : 0;
    const nonBillingPercentage = nonBillingProgress.toFixed(2) + "%";

    const totalProgress = working > 0 ? (total / working) * 100 : 0;
    const totalPercentage =
      total <= working
        ? totalProgress.toFixed(2) + "%"
        : `-${(totalProgress - 100).toFixed(2)}%`;

    const stats = {
      total: total.toFixed(2),
      working: working.toFixed(2),
      billing: billing.toFixed(2),
      nonBilling: nonBilling.toFixed(2),
      empbillingPercentage: billingPercentage,
      empnonBillingPercentage: nonBillingPercentage,
      emptotalPercentage: totalPercentage,
    };

    console.log(stats, "Summary Hours Stats");

    setSummaryHours(stats);
  }, [projectData, selectedEmployee, selectedTimePeriod]);

  const noDataWarning = () => {
    messageApi.destroy();
    messageApi.open({
      type: "warning",
      content: "No data to download",
    });
  };

  // const handleTimePeriodChange = (value) => {
  //   setSelectedTimePeriod(value)
  //   const currentStartDate = dayjs().startOf(value);
  //   const currentEndDate = dayjs().endOf(value);
  //   setSelectedDates([
  //     currentStartDate,
  //     currentEndDate,
  //   ])
  // }

  const handleTimePeriodChange = (value) => {
    setSelectedTimePeriod(value);

    const today = dayjs();

    if (value === "day") {
      setSelectedDates([today, today]);
      setSdate(today.format("YYYY-MM-DD"));
      setEdate(today.format("YYYY-MM-DD"));
    } else if (value === "week") {
      const start = today.startOf("isoWeek"); // Monday
      const end = today.endOf("isoWeek"); // Sunday
      setSelectedDates([start, end]);
      setSdate(start.format("YYYY-MM-DD"));
      setEdate(end.format("YYYY-MM-DD"));
    } else if (value === "month") {
      setSelectedDates([today.startOf("month"), today.endOf("month")]);
    } else if (value === "year") {
      setSelectedDates([today.startOf("year"), today.endOf("year")]);
    }
  };

  const handleProjectChange = (value) => {
    setSelectedProject(value);
    
    // Find and store the project name
    if (value && selectedClient && projectList[selectedClient]) {
      const project = projectList[selectedClient].find(
        (p) => String(p.projectId) === String(value)
      );
      if (project) {
        setSelectedProjectName(project.projectName);
      }
    } else if (value === "All") {
      setSelectedProjectName(null);
    }
  };
  // const handleTaskChange = (value) => {
  //   setSelectedTask(value);
  // };

  const formatTime = (totalMinutes) => {
    if (isNaN(totalMinutes) || totalMinutes == null) return "00:00"; // Handle NaN or null
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  function timeToFloatHours(timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const totalHours = hours + minutes / 60;
    console.log("typeof", typeof totalHours.toFixed(2));
    return totalHours.toFixed(2); // returns string like "4.00"
  }
  function minutesToFloatHours(minutesStr) {
    const minutes = parseFloat(minutesStr);
    const hours = minutes / 60;
    return hours.toFixed(2);
  }

  //New
  // const [selectedPriority, setSelectedPriority] = useState('All');
  const getCommentsHeader = () => {
    const items = ["None", "Group by Task"].map((item) => ({
      label: (
        <span
          style={{
            width: "100%",
            fontWeight: selectedGrouping === item ? "bold" : "normal",
            color: selectedGrouping === item ? "#1677ff" : "Black",
          }}
        >
          {item}
        </span>
      ),
      key: item,
    }));

    const handleCommentsMenuClick = (info) => {
      setSelectedGrouping(info.key);
      console.log("Selected:", info.key); // <-- Here you get the selected key
    };

    return (
      <Dropdown
        menu={{ items, onClick: handleCommentsMenuClick }}
        trigger={["click"]}
        className="w-full h-full cursor-pointer"
      >
        <a onClick={(e) => e.preventDefault()} className="hover:text-blue-500">
          <Space>
            Comments
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    );
  };
  //New End

  const columns = useMemo(() => {
    if (selectedType == 1) {
      return [
        {
          accessorKey: "comments_Date",
          header: "Date",
          size: 80,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "client_name",
          header: "Clients",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "project_name",
          header: "Projects",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "employee_name",
          header: "Employees",
          size: 50,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "task_name",
          header: "Tasks",
          size: 200,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "comments_data",
          header: "Comments",
          size: 250,
          enableColumnActions: false,
          enableSorting: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
        },
        {
          accessorKey: "Hours",
          header: "Hours",
          size: 50,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "right" } },
        },
      ];
    } else if (selectedType == 2) {
      return [
        {
          accessorKey: "client_name",
          header: "Clients",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "Hours",
          header: "Hours",
          size: 50,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "right" } },
        },
      ];
    } else if (selectedType === 3) {
      return [
        {
          accessorKey: "project",
          header: "Projects",
          size: 150, // Increased to accommodate longer project names
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "employee",
          header: "Employee",
          size: 180,
          minSize: 100,
          maxSize: 200,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
          Cell: ({ row }) => <div>{row.original.employee || ""}</div>,
        },
        {
          accessorKey: "comment",
          header: "Comments",
          size: 400,
          enableColumnActions: false,
          enableSorting: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => <div>{row.original.comment || ""}</div>,
        },
        {
          accessorKey: "Hours",
          header: "Hours",
          size: 100, // Kept narrow as it only needs to fit numeric values
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "right" } },
        },
      ];
    } else if (selectedType == 4) {
      return [
        {
          accessorKey: "employee_name",
          header: "Employees",
          size: 50,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "project_name",
          header: "Projects",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "comments_Date",
          header: "Date",
          size: 50,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },

        {
          accessorKey: "comment",
          header: "Comments",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "Hours",
          header: "Hours",
          size: 50,

          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "right" } },
        },
      ];
    } else if (selectedType === 5) {
      return [
        {
          accessorKey: "project",
          header: "Projects",
          size: 150,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "task",
          header: "Tasks",
          size: 150,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
          Cell: ({ row }) => {
            return <div>{row.original.task || ""}</div>;
          },
        },
        {
          accessorKey: "employee",
          header: "Employee",
          size: 150,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
          Cell: ({ row }) => {
            return <div>{row.original.employee || ""}</div>;
          },
        },
        {
          accessorKey: "comment",
          header: "Comments",
          size: 250,
          enableColumnActions: false,
          enableSorting: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => {
            return <div>{row.original.comment || ""}</div>;
          },
        },
        {
          accessorKey: "Hours",
          header: "Hours",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "right" } },
        },
      ];
    } else if (selectedType === 6) {
      return [
        {
          accessorKey: "client_name",
          header: "Client name",
          size: 150, // Increased to accommodate longer project names
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "left" } },
        },
        {
          accessorKey: "project_name",
          header: "Projects",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => <div>{row.original.project_name || ""}</div>,
        },
        // {
        //   accessorKey: 'task',
        //   header: 'Tasks',
        //   size: 150,
        //   enableColumnActions: false,
        //   muiTableHeadCellProps: { align: 'center' },
        //   muiTableBodyCellProps: { style: { textAlign: 'left' } },
        //   Cell: ({ row }) => {
        //     return <div>{row.original.task || ''}</div>;
        //   },
        // },
        // {
        //   accessorKey: 'Planned_Hours',
        //   header: 'Estimated Hours',
        //   size: 100,
        //   enableColumnActions: false,
        //   muiTableHeadCellProps: { align: 'center' },
        //   muiTableBodyCellProps: { style: { textAlign: 'justify' } },
        //   Cell: ({ row }) => <div>{row.original.Planned_Hours || ''}</div>,
        // },
        {
          accessorKey: "WeekHours",
          header: "Current week",
          size: 100,
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => <div>{row.original.WeekHours || ""}</div>,
        },
        {
          accessorKey: "pastweek",
          header: "Last week",
          size: 100,
          enableColumnActions: false,
          enableSorting: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => <div>{row.original.pastweek || ""}</div>,
        },
        {
          accessorKey: "MonthHours",
          header: "MTD",
          size: 100, // Kept narrow as it only needs to fit numeric values
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => <div>{row.original.MonthHours || ""}</div>,
        },
        {
          accessorKey: "YearyHours",
          header: "YTD",
          size: 100, // Kept narrow as it only needs to fit numeric values
          enableColumnActions: false,
          muiTableHeadCellProps: { align: "center" },
          muiTableBodyCellProps: { style: { textAlign: "justify" } },
          Cell: ({ row }) => <div>{row.original.YearyHours || ""}</div>,
        },
      ];
    }

    return [];
  }, [selectedType]);

  const options = [
    { label: "Day Report", value: "day" },
    { label: "Weekly Report", value: "week" },
    { label: "Monthly Report", value: "month" },
    { label: "Yearly Report", value: "year" },
  ];

  const GetAllemployee = async () => {
    const response = await Timesheetapi.post(`api/Projects/GetAllEmployee`);
    const employees = response.data.Empdetails;
    setEmployee([{ label: "All", value: 1 }, ...employees]);
  };

  const handleDateChange = (date, dateString) => {
    if (date && date.length === 2) {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const startMonth = date[0];
      const endMonth = date[1];

      if (
        selectedTimePeriod === "month" ||
        selectedTimePeriod === "year" ||
        selectedTimePeriod === "day"
      ) {
        const startOfMonth = dayjs(startMonth)
          .tz(userTimeZone)
          .startOf(selectedTimePeriod)
          .format("YYYY-MM-DD");
        const endOfMonth = dayjs(endMonth)
          .tz(userTimeZone)
          .endOf(selectedTimePeriod)
          .format("YYYY-MM-DD");

        console.log(startOfMonth, endOfMonth, "endOfMonth");
        setSdate(startOfMonth);
        setEdate(endOfMonth);
        return;
      }
    }
  };

  //changes being done
  const handleExportData = async (data, sdate, edate, selectedTimePeriod) => {
    if (projectData.length === 0) {
      noDataWarning();
      return;
    }

    // Helper: Format Date Range Title
    const formatDateRange = (start, end, type) => {
      const s = new Date(start);
      const e = new Date(end);
      switch (type) {
        case "day":
          return `DATE: ${s.toDateString()} - ${e.toDateString()}`;
        case "week":
          return `WEEK: ${s.toDateString()} - ${e.toDateString()}`;
        case "month":
          return `MONTH: ${s.toLocaleString("en-US", {
            month: "long",
            year: "numeric",
          })} - ${e.toLocaleString("en-US", {
            month: "long",
            year: "numeric",
          })}`;
        case "year":
          return `YEAR: ${s.getFullYear()} - ${e.getFullYear()}`;
        default:
          return `${s.toDateString()} - ${e.toDateString()}`;
      }
    };

    if (selectedType === 4) {
      const clientname =
        selectedClient === "All"
          ? "All Clients"
          : allClientList.find((client) => client.value === selectedClient);
      const projectname =
        selectedProject === "All"
          ? "All Projects"
          : projectList[selectedClient].find(
              (project) => project.projectId === selectedProject
            );

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Employee_Reports");

      worksheet.views = [{ state: "frozen", ySplit: 3 }];
      worksheet.properties.outlineProperties = { summaryBelow: true };

      worksheet.columns = [
        { header: "Employees", key: "employee_name", width: 30 },
        { header: "Projects", key: "project_name", width: 30 },
        { header: "Comment Date", key: "comments_Date", width: 10 },
        { header: "Comments", key: "comment", width: 50 },
        { header: "Count of Hours", key: "Hours", width: 15 },
      ];

      const lastColLetter = "E"; // Update to reflect new column count

      // Header and Date Range rows (unchanged)
      worksheet.mergeCells(`A1:${lastColLetter}1`);
      const headerCell = worksheet.getCell("A1");
      headerCell.value = `${
        selectedClient === "All" ? clientname : clientname.label
      } / ${selectedProject === "All" ? projectname : projectname.projectName}`;
      headerCell.font = { bold: true, size: 14 };
      headerCell.alignment = { horizontal: "center", vertical: "middle" };

      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = worksheet.getCell(String.fromCharCode(col) + 1);
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetter.charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      worksheet.mergeCells(`A2:${lastColLetter}2`);
      const titleCell = worksheet.getCell("A2");
      titleCell.value = formatDateRange(sdate, edate, selectedTimePeriod);
      titleCell.font = { bold: true, size: 12 };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };

      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = worksheet.getCell(String.fromCharCode(col) + 2);
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetter.charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      // Update header row
      worksheet.addRow([
        "Employees",
        "Projects",
        "Comment Date",
        "Comments",
        "Count of Hours",
      ]);
      worksheet.getRow(3).font = { bold: true };
      worksheet.getRow(3).eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Data export
      let grandTotal = 0;

      data.forEach((employee) => {
        const empRow = worksheet.addRow({
          employee_name: employee.employee_name,
          Hours: Number(employee.Hours),
        });
        empRow.font = { bold: true };
        empRow.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = {
            horizontal: colNumber === 5 ? "right" : "left",
            vertical: "middle",
          };
        });

        grandTotal += parseFloat(employee.Hours);

        employee.subRows.forEach((project) => {
          const projRow = worksheet.addRow({
            project_name: project.project_name,
            comments_Date: project.comments_Date, // Add comments_Date
            comment: project.comment,
            Hours: Number(project.Hours),
          });
          projRow.outlineLevel = 1;
          projRow.hidden = true;

          projRow.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = {
              horizontal: colNumber === 5 ? "right" : "left",
              vertical: "middle",
            };
          });
        });
      });

      // Total row
      const totalRow = worksheet.addRow(["", "", "", "", grandTotal]);
      const rowNum = totalRow.number;

      const totalLabelRange = `A${rowNum}:D${rowNum}`;
      worksheet.mergeCells(totalLabelRange);
      const totalLabelCell = worksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = "Overall Total";
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
      totalLabelCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const totalValueCell = worksheet.getCell(`E${rowNum}`);
      totalValueCell.font = { bold: true };
      totalValueCell.alignment = { horizontal: "right", vertical: "middle" };
      totalValueCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      for (let col = "A".charCodeAt(0); col <= "D".charCodeAt(0); col++) {
        const cell = worksheet.getCell(String.fromCharCode(col) + rowNum);
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right: col === "D".charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      totalValueCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const capitalizedPeriod =
        selectedTimePeriod === "day"
          ? "Days"
          : `${
              selectedTimePeriod.charAt(0).toUpperCase() +
              selectedTimePeriod.slice(1)
            }ly`;
      saveAs(
        blob,
        `${capitalizedPeriod}_Employee_Reports_${sdate}_to_${edate}.xlsx`
      );
      return;
    }

    if (selectedType === 5) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("High_Hrs_Task_Reports");

      const clientname =
        selectedClient === "All"
          ? "All Clients"
          : allClientList.find((client) => client.value === selectedClient);
      const projectname =
        selectedProject === "All"
          ? "All Projects"
          : projectList[selectedClient].find(
              (project) => project.projectId === selectedProject
            );

      // Freeze top 3 rows
      worksheet.views = [{ state: "frozen", ySplit: 3 }];
      worksheet.properties.outlineProperties = { summaryBelow: true };

      // Define columns
      worksheet.columns = [
        { header: "Projects", key: "project", width: 25 },
        { header: "Tasks", key: "task", width: 25 },
        { header: "Employee", key: "employee", width: 20 },
        { header: "Comments", key: "comment", width: 60 },
        { header: "Hours", key: "hours", width: 10 },
      ];

      const lastColLetter = "E";

      // Row 1: Title
      worksheet.mergeCells(`A1:${lastColLetter}1`);
      const headerCell = worksheet.getCell("A1");
      headerCell.value = `${
        selectedClient === "All" ? clientname : clientname.label
      } / ${selectedProject === "All" ? projectname : projectname.projectName}`;
      headerCell.font = { bold: true, size: 14 };
      headerCell.alignment = { horizontal: "center", vertical: "middle" };

      // Borders for Title row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = worksheet.getCell(String.fromCharCode(col) + "1");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetter.charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      // Row 2: Date Range
      worksheet.mergeCells(`A2:${lastColLetter}2`);
      const dateCell = worksheet.getCell("A2");
      dateCell.value = formatDateRange(sdate, edate, selectedTimePeriod);
      dateCell.font = { bold: true, size: 12 };
      dateCell.alignment = { horizontal: "center", vertical: "middle" };

      // Borders for Date row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = worksheet.getCell(String.fromCharCode(col) + "2");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetter.charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      // Row 3: Headers
      worksheet.addRow(["Projects", "Tasks", "Employee", "Comments", "Hours"]);
      const headerRow = worksheet.getRow(3);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      let totalHours = 0;

      data.forEach((project) => {
        // Project row
        const projectRow = worksheet.addRow({
          project: project.project,
          task: "",
          employee: "",
          comment: "",
          hours: parseFloat(project.Hours),
        });
        projectRow.font = { bold: true };
        totalHours += parseFloat(project.Hours);

        projectRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = {
            horizontal: cell.col === 5 ? "right" : "left",
            vertical: "middle",
          };
        });

        project.tasks.forEach((task) => {
          // Task row
          const taskRow = worksheet.addRow({
            project: "",
            task: task.task,
            employee: "",
            comment: "",
            hours: parseFloat(task.TaskHours),
          });
          taskRow.outlineLevel = 1;
          taskRow.hidden = true;

          taskRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = {
              horizontal: cell.col === 5 ? "right" : "left",
              vertical: "middle",
            };
          });

          task.comments.forEach((comment) => {
            // Comment row
            const commentRow = worksheet.addRow({
              project: "",
              task: "",
              employee: comment.Employee,
              comment: comment.content,
              hours: parseFloat(comment.Comment_hrs),
            });
            commentRow.outlineLevel = 2;
            commentRow.hidden = true;

            commentRow.eachCell((cell) => {
              cell.border = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
              };
              cell.alignment = {
                horizontal: cell.col === 5 ? "right" : "left",
                vertical: "middle",
              };
            });
          });
        });
      });

      // Total row
      const totalRow = worksheet.addRow([
        "",
        "",
        "",
        "Overall Total",
        totalHours,
      ]);
      const rowNum = totalRow.number;

      worksheet.mergeCells(`A${rowNum}:D${rowNum}`);
      const totalLabelCell = worksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = "Overall Total";
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
      totalLabelCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      // Borders for total row
      for (let col = "A".charCodeAt(0); col <= "D".charCodeAt(0); col++) {
        const cell = worksheet.getCell(String.fromCharCode(col) + rowNum);
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right: col === "D".charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      const totalValueCell = worksheet.getCell(`E${rowNum}`);
      totalValueCell.font = { bold: true };
      totalValueCell.alignment = { horizontal: "right", vertical: "middle" };
      totalValueCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };
      totalValueCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      // Save file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const capitalizedPeriod =
        selectedTimePeriod === "day"
          ? "Days"
          : `${
              selectedTimePeriod.charAt(0).toUpperCase() +
              selectedTimePeriod.slice(1)
            }ly`;
      saveAs(
        blob,
        `${capitalizedPeriod}_High_Hrs_Task_Reports_${sdate}_to_${edate}.xlsx`
      );
      return;
    }

    if (selectedType === 6) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Client Project Report");

      worksheet.views = [{ state: "frozen", ySplit: 3 }];
      worksheet.properties.outlineProperties = { summaryBelow: true };

      worksheet.columns = [
        { header: "Client", key: "client_name", width: 25 },
        { header: "Project", key: "project_name", width: 25 },
        { header: "Current week", key: "WeekHours", width: 15 },
        { header: "Past Week", key: "pastweek", width: 15 },
        { header: "Monthly Hours", key: "MonthHours", width: 15 },
        { header: "Yearly Hours", key: "YearyHours", width: 15 },
        { header: "Est Hours", key: "Est_hours", width: 15 },
      ];

      const lastColLetter = "F";

      worksheet.mergeCells(`A1:${lastColLetter}1`);
      const headerCell = worksheet.getCell("A1");
      headerCell.value = "Client-wise Project Summary";
      headerCell.font = { bold: true, size: 14 };
      headerCell.alignment = { horizontal: "center", vertical: "middle" };

      worksheet.mergeCells(`A2:${lastColLetter}2`);
      const titleCell = worksheet.getCell("A2");
      titleCell.value = formatDateRange(sdate, edate, selectedTimePeriod);
      titleCell.font = { bold: true, size: 12 };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };

      worksheet.addRow([
        "Client",
        "Project",
        "Current week",
        "Past Week",
        "Monthly Hours",
        "Yearly Hours",
        "Est Hours",
      ]);
      worksheet.getRow(3).font = { bold: true };
      worksheet.getRow(3).eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      let grandcurrentWeek = 0;
      let grandPastWeek = 0;
      let grandMonth = 0;
      let grandYear = 0;

      data.forEach((client) => {
        const clientRow = worksheet.addRow({
          client_name: client.client_name,
          WeekHours: parseFloat(client.WeekHours),
          pastweek: parseFloat(client.pastweek || 0),
          MonthHours: parseFloat(client.MonthHours || 0),
          YearyHours: parseFloat(client.YearyHours || 0),
          Est_hours: parseFloat(client.Est_hours || 0),
        });
        clientRow.font = { bold: true };
        clientRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { horizontal: "left", vertical: "middle" };
        });

        grandcurrentWeek += parseFloat(client.WeekHours);
        grandPastWeek += parseFloat(client.pastweek || 0);
        grandMonth += parseFloat(client.MonthHours || 0);
        grandYear += parseFloat(client.YearyHours || 0);

        client.subRows.forEach((project) => {
          const projRow = worksheet.addRow({
            project_name: project.project_name,
            WeekHours: parseFloat(project.WeekHours),
            pastweek: parseFloat(project.pastweek || 0),
            MonthHours: parseFloat(project.MonthHours || 0),
            YearyHours: parseFloat(project.YearyHours || 0),
          });
          projRow.outlineLevel = 1;
          projRow.hidden = true;
          projRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = { horizontal: "left", vertical: "middle" };
          });
        });
      });

      const totalRow = worksheet.addRow([
        "",
        "",
        grandcurrentWeek,
        grandPastWeek,
        grandMonth,
        grandYear,
      ]);
      const rowNum = totalRow.number;

      // worksheet.mergeCells(`A${rowNum}:B${rowNum}`);
      worksheet.mergeCells(`A${rowNum}:C${rowNum}`);
      const totalLabelCell = worksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = "Overall Total";
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
      totalLabelCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      // for (let col = 'C'.charCodeAt(0); col <= lastColLetter.charCodeAt(0); col++) {
      for (
        let col = "D".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = worksheet.getCell(String.fromCharCode(col) + rowNum);
        cell.font = { bold: true };
        cell.alignment = { horizontal: "right", vertical: "middle" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "D9D9D9" },
        };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `Client_Project_Report_${sdate}_to_${edate}.xlsx`);
      return;
    }

    // Types 1-3 configuration
    const clientname =
      selectedClient === "All"
        ? "All Clients"
        : allClientList.find((client) => client.value === selectedClient);
    const projectname =
      selectedProject === "All"
        ? "All Projects"
        : projectList[selectedClient].find(
            (project) => project.projectId === selectedProject
          );

    const columnMap = {
      1: {
        headers: [
          "Date",
          "Clients",
          "Projects",
          "Employees",
          "Tasks",
          "Comments",
          "Hours",
        ],
        keys: [
          "comments_Date",
          "client_name",
          "project_name",
          "employee_name",
          "task_name",
          "comments_data",
          "Hours",
        ],
        widths: [20, 20, 30, 40, 60, 10],
        reportLabel: "All_Reports",
      },
      2: {
        headers: ["Clients", "Hours"],
        keys: ["client_name", "Hours"],
        widths: [30, 30],
        reportLabel: "Client_Reports",
      },
      3: {
        headers: ["Projects", "Hours"],
        keys: ["project_name", "Hours"],
        widths: [30, 30],
        reportLabel: "Project_Reports",
      },
    };
    const colConfig = columnMap[selectedType];

    if (!colConfig) {
      console.error("Unsupported selectedType:", selectedType);
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(colConfig.reportLabel || "Reports");
    worksheet.views = [{ state: "frozen", ySplit: 3 }];

    const title = formatDateRange(sdate, edate, selectedTimePeriod);
    const lastColLetter = String.fromCharCode(64 + colConfig.keys.length);

    // Row 1: Dynamic Title
    worksheet.mergeCells(`A1:${lastColLetter}1`);
    const headerCell = worksheet.getCell("A1");
    if (selectedType === 1) {
      headerCell.value = `${
        selectedClient === "All" ? clientname : clientname.label
      } / ${selectedProject === "All" ? projectname : projectname.projectName}`;
    } else if (selectedType === 2) {
      headerCell.value = `${
        selectedClient === "All" ? clientname : clientname.label
      }`;
    } else if (selectedType === 3) {
      headerCell.value = `${
        selectedProject === "All" ? projectname : projectname.projectName
      }`;
    } else {
      headerCell.value = "";
    }
    headerCell.font = { bold: true, size: 14 };
    headerCell.alignment = { horizontal: "center", vertical: "middle" };

    // Row 2: Date Range Title
    worksheet.mergeCells(`A2:${lastColLetter}2`);
    const titleCell = worksheet.getCell("A2");
    titleCell.value = title;
    titleCell.font = { bold: true, size: 12 };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };

    // Row 3: Column Headers
    worksheet.addRow(colConfig.headers);
    worksheet.columns = colConfig.keys.map((key, idx) => ({
      key,
      width: colConfig.widths[idx],
    }));
    worksheet.getRow(3).font = { bold: true };

    // Add data rows
    let totalMinutes = 0;
    data.forEach((row) => {
      if (
        row.task_name?.toLowerCase() !== "off" &&
        row.task_name?.toLowerCase() !== "leave"
      ) {
        totalMinutes += Number(Number(row.Hours).toFixed(2));
      }
      const rowData = {};
      colConfig.keys.forEach((key) => {
        rowData[key] = key === "Hours" ? Number(row[key]) : row[key];
      });
      worksheet.addRow(rowData);
    });

    // Add Total Row
    const totalRow = worksheet.addRow([
      ...Array(colConfig.keys.length - 1).fill(""),
      totalMinutes,
    ]);
    const rowNum = totalRow.number;

    const totalLabelRange = `A${rowNum}:${String.fromCharCode(
      64 + colConfig.keys.length - 1
    )}${rowNum}`;
    worksheet.mergeCells(totalLabelRange);
    const totalLabelCell = worksheet.getCell(`A${rowNum}`);
    totalLabelCell.value = "Overall Total";
    totalLabelCell.font = { bold: true };
    totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
    totalLabelCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D9D9D9" },
    };

    const totalValueCell = worksheet.getCell(`${lastColLetter}${rowNum}`);
    totalValueCell.font = { bold: true };
    totalValueCell.alignment = { horizontal: "right", vertical: "middle" };
    totalValueCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D9D9D9" },
    };

    // Style all data rows
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        if (rowNumber > 3 && rowNumber < rowNum) {
          cell.alignment = {
            horizontal: colNumber === colConfig.keys.length ? "right" : "left",
            vertical: "middle",
            wrapText: true,
          };
        }
      });
    });

    // Border for total row
    totalRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Add Employee Summary sheet for selectedType 1
    if (selectedType === 1) {
      // Calculate available hours
      const getWorkedHours = (startDate, endDate) => {
        const today = new Date();
        const effectiveEnd = endDate > today ? today : endDate;
        let count = 0;
        let current = new Date(startDate);
        while (current <= effectiveEnd) {
          const day = current.getDay();
          if (day !== 0 && day !== 6) count++;
          current.setDate(current.getDate() + 1);
        }
        return count * 8;
      };
      const leaveHours = data.reduce((sum, row) => {
        if (
          row.task_name?.toLowerCase() === "leave" ||
          row.task_name?.toLowerCase() === "off"
        ) {
          return sum + parseFloat(row.Hours || 0);
        }
        return sum;
      }, 0);
      const availableHours = Math.max(
        0,
        getWorkedHours(new Date(sdate), new Date(edate)) - leaveHours
      );

      const employeeSummary = {};
      data.forEach((row) => {
        const emp = row.employee_name;
        if (!employeeSummary[emp]) {
          employeeSummary[emp] = {
            billing: 0,
            nonBilling: 0,
            total: 0,
            leave: 0,
          };
        }
        const hrs = parseFloat(row.Hours) || 0;
        if (
          row.task_name?.toLowerCase() === "leave" ||
          row.task_name?.toLowerCase() === "off"
        ) {
          employeeSummary[emp].leave += hrs;
          return;
        }
        employeeSummary[emp].total += hrs;
        // if (
        //   row.task_name?.toLowerCase().includes("non billable") ||
        //   row.task_name?.toLowerCase().includes("bench") ||
        //   row.task_name?.toLowerCase().includes("non - billable") ||
        //   (row.task_name?.toLowerCase().includes("infra") &&
        //     row.client_name === "RCK Techiees") ||
        //   row.task_name?.toLowerCase().includes("training and certification") ||
        //   row.project_name?.toLowerCase().includes("rck market place app") ||
        //   row.project_name?.toLowerCase().includes("freshwork market app")
        // ) 
        if (row.Billing_Status == 0) 
        {
          employeeSummary[emp].nonBilling += hrs;
        } else {
          employeeSummary[emp].billing += hrs;
        }
      });

      const summaryWorksheet = workbook.addWorksheet("Employee Summary");
      summaryWorksheet.columns = [
        { header: "Employee Name", key: "employee_name", width: 30 },
        { header: "Available Hours", key: "available", width: 15 },
        { header: "Billing Hours", key: "billing", width: 15 },
        { header: "Non-Billing Hours", key: "nonBilling", width: 15 },
        { header: "Total Hours", key: "total", width: 15 },
        { header: "Leave Hours", key: "leave", width: 15 },
        { header: "Utilization", key: "utilization", width: 15 },
      ];

      const lastColLetter = "G";

      // Row 1: Title
      summaryWorksheet.mergeCells(`A1:${lastColLetter}1`);
      const headerCell = summaryWorksheet.getCell("A1");
      headerCell.value = "Employee Summary";
      headerCell.font = { bold: true, size: 14 };
      headerCell.alignment = { horizontal: "center", vertical: "middle" };

      // Borders for Title row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = summaryWorksheet.getCell(String.fromCharCode(col) + "1");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetter.charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      // Row 2: Date Range
      summaryWorksheet.mergeCells(`A2:${lastColLetter}2`);
      const dateCell = summaryWorksheet.getCell("A2");
      dateCell.value = formatDateRange(sdate, edate, selectedTimePeriod);
      dateCell.font = { bold: true, size: 12 };
      dateCell.alignment = { horizontal: "center", vertical: "middle" };

      // Borders for Date row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetter.charCodeAt(0);
        col++
      ) {
        const cell = summaryWorksheet.getCell(String.fromCharCode(col) + "2");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetter.charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      // Row 3: Headers
      summaryWorksheet.addRow([
        "Employee Name",
        "Available Hours",
        "Billing Hours",
        "Non-Billing Hours",
        "Total Hours",
        "Leave Hours",
        "Utilization",
      ]);
      const headerRow = summaryWorksheet.getRow(3);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Data rows starting from row 4
      Object.keys(employeeSummary).forEach((emp) => {
        const empAvailable = Math.max(
          0,
          getWorkedHours(new Date(sdate), new Date(edate)) -
            employeeSummary[emp].leave
        );
        const dataRow = summaryWorksheet.addRow({
          employee_name: emp,
          available: empAvailable,
          billing: employeeSummary[emp].billing.toFixed(2),
          utilization:
            empAvailable > 0
              ? ((employeeSummary[emp].billing / empAvailable) * 100).toFixed(
                  2
                ) + "%"
              : "0.00%",
          nonBilling: employeeSummary[emp].nonBilling.toFixed(2),
          total: employeeSummary[emp].total.toFixed(2),
          leave: employeeSummary[emp].leave.toFixed(2),
        });
        dataRow.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = {
            horizontal: colNumber === 1 ? "left" : "right",
            vertical: "middle",
          };
          if (colNumber === 4) {
            // Utilization column
            const value = cell.value;
            if (value && typeof value === "string" && value.includes("%")) {
              const percent = parseFloat(value.replace("%", ""));
              if (percent > 100) {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "FFFF0000" }, // red
                };
              }
            }
          }
        });
      });

      // Calculate grand totals
      let grandBilling = 0;
      let grandNonBilling = 0;
      let grandTotal = 0;
      let grandLeave = 0;

      Object.keys(employeeSummary).forEach((emp) => {
        grandBilling += employeeSummary[emp].billing;
        grandNonBilling += employeeSummary[emp].nonBilling;
        grandTotal += employeeSummary[emp].total;
        grandLeave += employeeSummary[emp].leave;
      });

      // Add grand total row
      const totalRow = summaryWorksheet.addRow({
        employee_name: "",
        available: "",
        billing: grandBilling.toFixed(2),
        nonBilling: grandNonBilling.toFixed(2),
        total: grandTotal.toFixed(2),
        leave: grandLeave.toFixed(2),
        utilization:
          availableHours > 0
            ? ((grandBilling / availableHours) * 100).toFixed(2) + "%"
            : "0.00%",
      });
      const rowNum = totalRow.number;
      const totalLabelRange = `A${rowNum}:B${rowNum}`;
      summaryWorksheet.mergeCells(totalLabelRange);
      const totalLabelCell = summaryWorksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = "Overall Total";
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
      totalLabelCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const availableCell = summaryWorksheet.getCell(`B${rowNum}`);
      availableCell.font = { bold: true };
      availableCell.alignment = { horizontal: "center", vertical: "middle" };
      availableCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const billingCell = summaryWorksheet.getCell(`C${rowNum}`);
      billingCell.font = { bold: true };
      billingCell.alignment = { horizontal: "right", vertical: "middle" };
      billingCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const nonBillingCell = summaryWorksheet.getCell(`D${rowNum}`);
      nonBillingCell.font = { bold: true };
      nonBillingCell.alignment = { horizontal: "right", vertical: "middle" };
      nonBillingCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const totalCell = summaryWorksheet.getCell(`E${rowNum}`);
      totalCell.font = { bold: true };
      totalCell.alignment = { horizontal: "right", vertical: "middle" };
      totalCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const leaveCell = summaryWorksheet.getCell(`F${rowNum}`);
      leaveCell.font = { bold: true };
      leaveCell.alignment = { horizontal: "right", vertical: "middle" };
      leaveCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const utilCell = summaryWorksheet.getCell(`G${rowNum}`);
      utilCell.font = { bold: true };
      utilCell.alignment = { horizontal: "right", vertical: "middle" };
      const value = utilCell.value;
      if (value && typeof value === "string" && value.includes("%")) {
        const percent = parseFloat(value.replace("%", ""));
        if (percent > 100) {
          utilCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF0000" },
          };
        } else {
          utilCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9D9D9" },
          };
        }
      } else {
        utilCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "D9D9D9" },
        };
      }

      for (let col = "A".charCodeAt(0); col <= "B".charCodeAt(0); col++) {
        const cell = summaryWorksheet.getCell(
          String.fromCharCode(col) + rowNum
        );
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right: col === "B".charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      billingCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      nonBillingCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      totalCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      leaveCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      utilCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    }

    // Add Client Summary sheet
    if (selectedType === 1) {
      const clientEstimated = {};
      allClientList.forEach((client) => {
        if (client.value !== "All" && projectList[client.value]) {
          let totalEst = 0;
          projectList[client.value].forEach((project) => {
            const est = calculateEstimatedHoursBreakdown(project.projectId);
            totalEst += parseFloat(est.total);
          });
          clientEstimated[client.value] = totalEst;
        }
      });
      const clientWorked = {};
      data.forEach((row) => {
        const client = row.client_name;
        if (!clientWorked[client]) clientWorked[client] = 0;
        if (
          row.task_name?.toLowerCase() !== "off" &&
          row.task_name?.toLowerCase() !== "leave"
        ) {
          clientWorked[client] += parseFloat(row.Hours) || 0;
        }
      });
      const clientSummary = {};
      allClientList.forEach((client) => {
        if (client.value !== "All") {
          const assigned = parseFloat(client.assigned_hours) || 0;
          const estimated = clientEstimated[client.value] || 0;
          const hours = assigned > 0 ? assigned : estimated;
          clientSummary[client.label] = hours.toFixed(2);
        }
      });
      const clientWorksheet = workbook.addWorksheet("Client Summary");
      clientWorksheet.columns = [
        { header: "Client Name", key: "client_name", width: 30 },
        { header: "Client Hours", key: "hours", width: 15 },
        { header: "Worked Hours", key: "worked_hours", width: 15 },
        { header: "Utilization", key: "utilization", width: 15 },
      ];
      const lastColLetterClient = "D";
      // Row 1: Title
      clientWorksheet.mergeCells(`A1:${lastColLetterClient}1`);
      const clientHeaderCell = clientWorksheet.getCell("A1");
      clientHeaderCell.value = "Client Summary";
      clientHeaderCell.font = { bold: true, size: 14 };
      clientHeaderCell.alignment = { horizontal: "center", vertical: "middle" };
      // Borders for Title row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetterClient.charCodeAt(0);
        col++
      ) {
        const cell = clientWorksheet.getCell(String.fromCharCode(col) + "1");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetterClient.charCodeAt(0)
              ? { style: "thin" }
              : undefined,
        };
      }
      // Row 2: Date Range
      clientWorksheet.mergeCells(`A2:${lastColLetterClient}2`);
      const clientDateCell = clientWorksheet.getCell("A2");
      clientDateCell.value = formatDateRange(sdate, edate, selectedTimePeriod);
      clientDateCell.font = { bold: true, size: 12 };
      clientDateCell.alignment = { horizontal: "center", vertical: "middle" };
      // Borders for Date row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetterClient.charCodeAt(0);
        col++
      ) {
        const cell = clientWorksheet.getCell(String.fromCharCode(col) + "2");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetterClient.charCodeAt(0)
              ? { style: "thin" }
              : undefined,
        };
      }
      // Row 3: Headers
      clientWorksheet.addRow([
        "Client Name",
        "Client Hours",
        "Worked Hours",
        "Utilization",
      ]);
      const clientHeaderRow = clientWorksheet.getRow(3);
      clientHeaderRow.font = { bold: true };
      clientHeaderRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
      // Data rows
      Object.keys(clientSummary).forEach((client) => {
        const dataRow = clientWorksheet.addRow({
          client_name: client,
          hours: clientSummary[client],
          worked_hours: (clientWorked[client] || 0).toFixed(2),
          utilization:
            parseFloat(clientSummary[client]) > 0
              ? (
                  (parseFloat(clientWorked[client] || 0) /
                    parseFloat(clientSummary[client])) *
                  100
                ).toFixed(2) + "%"
              : "0.00%",
        });
        dataRow.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = {
            horizontal: colNumber === 1 ? "left" : "right",
            vertical: "middle",
          };
          if (colNumber === 4) {
            // Utilization column
            const value = cell.value;
            if (value && typeof value === "string" && value.includes("%")) {
              const percent = parseFloat(value.replace("%", ""));
              if (percent > 100) {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "FFFF0000" }, // red
                };
              }
            }
          }
        });
      });

      // Add special row for FreshWork APP
      const specialWorked = data.reduce((sum, row) => {
        if (
          row.project_name
            ?.toLowerCase()
            .includes("training and certification") ||
          row.project_name?.toLowerCase().includes("rck market place app") ||
          row.project_name?.toLowerCase().includes("freshwork market app")
        ) {
          return sum + parseFloat(row.Hours || 0);
        }
        return sum;
      }, 0);
      const specialRow = clientWorksheet.addRow({
        client_name: "FreshWork App",
        hours: "0.00",
        worked_hours: specialWorked.toFixed(2),
        utilization: "0.00%",
      });
      specialRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = {
          horizontal: colNumber === 1 ? "left" : "right",
          vertical: "middle",
        };
        if (colNumber === 4) {
          // Utilization column
          const value = cell.value;
          if (value && typeof value === "string" && value.includes("%")) {
            const percent = parseFloat(value.replace("%", ""));
            if (percent > 100) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFF0000" }, // red
              };
            }
          }
        }
      });

      // Calculate grand totals for Client Summary
      let grandClientHours = 0;
      let grandWorkedHours = 0;
      Object.keys(clientSummary).forEach((client) => {
        grandClientHours += parseFloat(clientSummary[client]);
        grandWorkedHours += parseFloat(clientWorked[client] || 0);
      });
      const grandUtilization =
        grandClientHours > 0
          ? ((grandWorkedHours / grandClientHours) * 100).toFixed(2) + "%"
          : "0.00%";

      // Add total row
      const totalRow = clientWorksheet.addRow({
        client_name: "Overall Total",
        hours: grandClientHours.toFixed(2),
        worked_hours: grandWorkedHours.toFixed(2),
        utilization: grandUtilization,
      });
      totalRow.font = { bold: true };
      totalRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = {
          horizontal: colNumber === 1 ? "left" : "right",
          vertical: "middle",
        };
        if (colNumber === 4) {
          // Utilization
          const value = cell.value;
          if (value && typeof value === "string" && value.includes("%")) {
            const percent = parseFloat(value.replace("%", ""));
            if (percent > 100) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFF0000" },
              };
            } else {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "D9D9D9" },
              };
            }
          } else {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "D9D9D9" },
            };
          }
        } else {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9D9D9" },
          };
        }
      });
    }

    // Add Project Summary sheet
    if (selectedType === 1) {
      const projectEstimated = {};
      const projectWorked = {};

      // Collect all projects and their estimated hours
      allClientList.forEach((client) => {
        if (client.value !== "All" && projectList[client.value]) {
          projectList[client.value].forEach((project) => {
            const projectInfo = rawData.find(
              (p) => String(p.Project_id) === String(project.projectId)
            );
            // ✅ FILTER: Skip if status is 3
            if (projectInfo && projectInfo.status === 3) {
              return; // Skip this project
            }

            const est = calculateEstimatedHoursBreakdown(project.projectId);
            projectEstimated[project.projectId] = {
              hours: parseFloat(est.total),
              name: project.projectName,
              client: client.label,
            };
          });
        }
      });

      // Collect worked hours per project
      data.forEach((row) => {
        const projectId = row.project_id;
        const projectInfo = rawData.find(
          (p) => String(p.Project_id) === String(projectId)
        );

        // ✅ FILTER: Skip if status is 3
        if (projectInfo && projectInfo.status === 3) {
          return; // Skip this project
        }

        if (!projectWorked[projectId]) projectWorked[projectId] = 0;
        if (
          row.task_name?.toLowerCase() !== "off" &&
          row.task_name?.toLowerCase() !== "leave"
        ) {
          projectWorked[projectId] += parseFloat(row.Hours) || 0;
        }
      });

      const projectWorksheet = workbook.addWorksheet("Project Summary");
      projectWorksheet.columns = [
        { header: "Client Name", key: "client_name", width: 30 },
        { header: "Project Name", key: "project_name", width: 30 },
        { header: "Project Hours", key: "hours", width: 15 },
        { header: "Worked Hours", key: "worked_hours", width: 15 },
        { header: "Utilization", key: "utilization", width: 15 },
      ];
      const lastColLetterProject = "E";

      // Row 1: Title
      projectWorksheet.mergeCells(`A1:${lastColLetterProject}1`);
      const projectHeaderCell = projectWorksheet.getCell("A1");
      projectHeaderCell.value = "Project Summary";
      projectHeaderCell.font = { bold: true, size: 14 };
      projectHeaderCell.alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      // Borders for Title row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetterProject.charCodeAt(0);
        col++
      ) {
        const cell = projectWorksheet.getCell(String.fromCharCode(col) + "1");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetterProject.charCodeAt(0)
              ? { style: "thin" }
              : undefined,
        };
      }

      // Row 2: Date Range
      projectWorksheet.mergeCells(`A2:${lastColLetterProject}2`);
      const projectDateCell = projectWorksheet.getCell("A2");
      projectDateCell.value = formatDateRange(sdate, edate, selectedTimePeriod);
      projectDateCell.font = { bold: true, size: 12 };
      projectDateCell.alignment = { horizontal: "center", vertical: "middle" };
      // Borders for Date row
      for (
        let col = "A".charCodeAt(0);
        col <= lastColLetterProject.charCodeAt(0);
        col++
      ) {
        const cell = projectWorksheet.getCell(String.fromCharCode(col) + "2");
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right:
            col === lastColLetterProject.charCodeAt(0)
              ? { style: "thin" }
              : undefined,
        };
      }

      // Row 3: Headers
      projectWorksheet.addRow([
        "Client Name",
        "Project Name",
        "Project Hours",
        "Worked Hours",
        "Utilization",
      ]);
      const projectHeaderRow = projectWorksheet.getRow(3);
      projectHeaderRow.font = { bold: true };
      projectHeaderRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Data rows
      Object.keys(projectEstimated).forEach((projectId) => {
        const proj = projectEstimated[projectId];
        const worked = projectWorked[projectId] || 0;
        const utilization =
          proj.hours > 0
            ? ((worked / proj.hours) * 100).toFixed(2) + "%"
            : "0.00%";
        const dataRow = projectWorksheet.addRow({
          client_name: proj.client,
          project_name: proj.name,
          hours: proj.hours.toFixed(2),
          worked_hours: worked.toFixed(2),
          utilization: utilization,
        });
        dataRow.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = {
            horizontal: colNumber <= 2 ? "left" : "right",
            vertical: "middle",
          };
          if (colNumber === 5) {
            // Utilization column
            const value = cell.value;
            if (value && typeof value === "string" && value.includes("%")) {
              const percent = parseFloat(value.replace("%", ""));
              if (percent > 100) {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "FFFF0000" }, // red
                };
              }
            }
          }
        });
      });

      // Calculate grand totals for Project Summary
      let grandProjectHours = 0;
      let grandWorkedHours = 0;
      Object.keys(projectEstimated).forEach((projectId) => {
        grandProjectHours += projectEstimated[projectId].hours;
        grandWorkedHours += projectWorked[projectId] || 0;
      });
      const grandUtilization =
        grandProjectHours > 0
          ? ((grandWorkedHours / grandProjectHours) * 100).toFixed(2) + "%"
          : "0.00%";

      // Add total row
      const totalRow = projectWorksheet.addRow({
        client_name: "",
        project_name: "",
        hours: grandProjectHours.toFixed(2),
        worked_hours: grandWorkedHours.toFixed(2),
        utilization: grandUtilization,
      });
      const rowNum = totalRow.number;

      const totalLabelRange = `A${rowNum}:B${rowNum}`;
      projectWorksheet.mergeCells(totalLabelRange);
      const totalLabelCell = projectWorksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = "Overall Total";
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
      totalLabelCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const totalHoursCell = projectWorksheet.getCell(`C${rowNum}`);
      totalHoursCell.font = { bold: true };
      totalHoursCell.alignment = { horizontal: "right", vertical: "middle" };
      totalHoursCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const totalWorkedCell = projectWorksheet.getCell(`D${rowNum}`);
      totalWorkedCell.font = { bold: true };
      totalWorkedCell.alignment = { horizontal: "right", vertical: "middle" };
      totalWorkedCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9D9D9" },
      };

      const totalUtilCell = projectWorksheet.getCell(`E${rowNum}`);
      totalUtilCell.font = { bold: true };
      totalUtilCell.alignment = { horizontal: "right", vertical: "middle" };
      const value = totalUtilCell.value;
      if (value && typeof value === "string" && value.includes("%")) {
        const percent = parseFloat(value.replace("%", ""));
        if (percent > 100) {
          totalUtilCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF0000" },
          };
        } else {
          totalUtilCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9D9D9" },
          };
        }
      } else {
        totalUtilCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "D9D9D9" },
        };
      }

      for (let col = "A".charCodeAt(0); col <= "B".charCodeAt(0); col++) {
        const cell = projectWorksheet.getCell(
          String.fromCharCode(col) + rowNum
        );
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: col === "A".charCodeAt(0) ? { style: "thin" } : undefined,
          right: col === "B".charCodeAt(0) ? { style: "thin" } : undefined,
        };
      }

      totalHoursCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      totalWorkedCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };

      totalUtilCell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    }

    // Save Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const capitalizedPeriod =
        selectedTimePeriod === "day"
          ? "Days"
          : `${
              selectedTimePeriod.charAt(0).toUpperCase() +
              selectedTimePeriod.slice(1)
            }ly`;
      const reportLabel = colConfig.reportLabel || "Report";
      const filename = `${capitalizedPeriod}_${reportLabel}_${sdate}_to_${edate}.xlsx`;
      saveAs(new Blob([buffer]), filename);
    });
  };

  const getAllClients = async () => {
    const storedClientIds =
      JSON.parse(localStorage.getItem("Emp_Assign_client")) || [];
    const Role_id = JSON.parse(localStorage.getItem("emp_role_id")) || [];
    const currentStartDate = dayjs().startOf("month").format("YYYY-MM-DD");
    const currentEndDate = dayjs().endOf("month").format("YYYY-MM-DD");
    const response = await Timesheetapi.get(
      `api/Projects/getclientlist?Role_id=${Role_id}&empid=${localStorage.getItem(
        "employee_id"
      )}&sdate=${currentStartDate}&edate=${currentEndDate}`
    );
    const clientOptions = response.data.Clients.filter((project) => {
      if (Role_id == 6) {
        return storedClientIds.includes(project.client_id);
      }
      return true;
    })
      .map((project) => ({
        value: project.client_id,
        label: project.client_name,
        assigned_hours: project.assigned_hours || 0,
        hours_type: project.hours_type,
      }))
      .filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
    setAllClientList([
      {
        label: "All",
        value: "All",
        assigned_hours: 0,
      },
      ...clientOptions,
    ]);
    console.log("CLIENTS ERROR IN PROJECT LIST", clientOptions[0]?.clientId);
    setSelectedClient("All");
  };

  //Gets all the projects list
  const getAllProjects = async (initialClient) => {
    const Role_id = JSON.parse(localStorage.getItem("emp_role_id")) || [];
    const response = await Timesheetapi.get(
      `api/Projects/getprojectdetails?Role_id=${Role_id}&empid=${localStorage.getItem(
        "employee_id"
      )}&Client_id=${initialClient}`
    );
    const projectOptions = response.data.projects.reduce((acc, project) => {
      const { client_id, Project_id, projectname, status } = project;
      
      // Get project name from multiple possible field names
      const projName = projectname || project.Project_name || project.projectName || project.project_name || `Project-${Project_id}`;

      if (status !== 3) {
        if (!acc[client_id]) {
          acc[client_id] = [];
        }

        acc[client_id].push({
          projectId: Project_id,
          projectName: projName,
          // status: status,
        });
      }

      return acc;
    }, {});

    setProjectList(projectOptions);
    //console.log("PROJECT ERROR IN PROJECT LIST", projectOptions)
    setSelectedProject("All");
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // const getHoursByClient = (data) =>
  //       data.Tasklist
  //         .flatMap(p => p.Tasks)
  //         .flatMap(t => t.Task_comments?.map(c => ({ ...c, Client_id: t.Client_id, Client_name: t.Client_name })) || [])
  //         .reduce((acc, c) => {
  //           const [h, m] = (c.Comment_hrs || "00:00").split(":").map(Number);
  //           const key = c.Client_id;
  //           if (!acc[key]) acc[key] = { name: c.Client_name, minutes: 0 };
  //           acc[key].minutes += h * 60 + m;
  //           return acc;
  //         }, {});

  // const getHoursByClient = (data) =>
  // data.Tasklist
  //   .flatMap(p => p.Tasks)
  //   .reduce((acc, task) => {

  //     const key = task.Client_id;

  //     if (!acc[key]) {
  //       acc[key] = {
  //         name: task.Client_name,
  //         minutes: 0,
  //         plannedHours: 0
  //       };
  //     }

  //     // Sum Planned Hours
  //     acc[key].plannedHours += Number(task.Planned_Hours || 0);

  //     // Sum Comment Hours
  //     (task.Task_comments || []).forEach(c => {
  //       const [h, m] = (c.Comment_hrs || "00:00")
  //         .split(":")
  //         .map(Number);

  //       acc[key].minutes += h * 60 + m;
  //     });

  //     return acc;
  //   }, {});

  const getHoursByClient = (data) =>
  data.Tasklist
    .flatMap(p => p.Tasks)
    .reduce((acc, task) => {

      const key = task.Client_id;

      if (!acc[key]) {
        acc[key] = {
          name: task.Client_name,
          minutes: 0,
          plannedHours: 0,
          plannedItemIds: new Set()
        };
      }

      // Add Planned Hours only once per ItemId
      if (!acc[key].plannedItemIds.has(task.ItemId)) {
        acc[key].plannedHours += Number(task.Planned_Hours || 0);
        acc[key].plannedItemIds.add(task.ItemId);
      }

      // Add Comment Hours from every employee/task
      (task.Task_comments || []).forEach(c => {
        const [h, m] = (c.Comment_hrs || "00:00")
          .split(":")
          .map(Number);

        acc[key].minutes += h * 60 + m;
      });

      return acc;
    }, {});

  const getAllApiData = async (client) => {
    setloading(true);
    //console.log('setClientChanged', sDate, eDate)
    //console.log("CLIENTS ERROR IN PROJECT LIST 1", client)
    try {
      const response = await Timesheetapi.get(
        `api/Projects/GetProjectReport?Sdate=${sDate}&Edate=${eDate}&Client_Id=${client}`
      );
      if (response.status === 200) {
        setloading(false);
        console.log("tempTotalhrs data : ", response.data);
        const tempTotalhrs = getHoursByClient(response.data);
        setClientWiseTHrs(tempTotalhrs);
        console.log("Client Wise Totl Hrs : ", tempTotalhrs);
        
        console.log("Data", response.data.Tasklist);
        setRawData(response.data.Tasklist);
        console.error("status code", response.data.Tasklist);
      } else {
        console.error("Error: Received non-200 status code", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setloading(false);
    }
  };
  function timeToFloatHours(timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours + minutes / 60;
  }

  function minutesToFloatHours(minStr) {
    const minutes = parseFloat(minStr);
    return isNaN(minutes) ? 0 : minutes / 60;
  }

  const handleExportVisibleData = () => {
    if (tableRef.current) {
      const visibleRows = tableRef.current.getPaginationRowModel().rows;
      const exportData = visibleRows.map((row) => row.original);
      console.log("DATA TO BE EXPORTED", exportData);

      handleExportData(projectData, sDate, eDate, selectedTimePeriod);
    }
  };

  const formatDateToDDMMYYYY = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
  };

  const handleWeekSelection = (selectedDates_, instance) => {
    if (instance) {
      instance.close();
    }

    if (selectedDates_.length > 0) {
      const selectedTempDate = selectedDates_[0];

      // Normalize to start of day to avoid timezone drift
      selectedTempDate.setHours(0, 0, 0, 0);

      const startOfWeek = new Date(selectedTempDate);
      const dayOfWeek = startOfWeek.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

      startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
      startOfWeek.setHours(0, 0, 0, 0); // Normalize again just in case

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(0, 0, 0, 0); // Normalize

      setSelectedWeekDates([startOfWeek, endOfWeek]);
      setSdate(formatDateToDDMMYYYY(new Date(startOfWeek)));
      setEdate(formatDateToDDMMYYYY(new Date(endOfWeek)));

      // console.log("ytrew", [
      //   formatDateToDDMMYYYY(new Date(startOfWeek)),
      //   formatDateToDDMMYYYY(new Date(endOfWeek))
      // ]);

      const newDateList = Array.from({ length: 7 }, (_, index) => {
        const date = new Date(startOfWeek);
        date.setDate(startOfWeek.getDate() + index);
        date.setHours(0, 0, 0, 0); // Normalize

        const formattedDate = date.toLocaleDateString("en-US", {
          timeZone: "UTC", // Add this for consistency
          weekday: "short",
          month: "short",
          day: "numeric",
        });

        //console.log(formattedDate, 'selectedDates_');

        return {
          accessorKey: formattedDate,
          header: formattedDate,
        };
      });

      setDateList(newDateList);
    }
  };

  useEffect(() => {
    if (Secret_key != null && Secret_key != "") {
    }
  }, [Secret_key]);

  useEffect(() => {
    // if ([1, 2, 3, 4, 5].includes(selectedType)) {
    const initialRender = async () => {
      if (
        selectedTimePeriod === "month" ||
        selectedTimePeriod === "year" ||
        selectedTimePeriod === "day"
      ) {
        const currentStartDate = dayjs().utc().startOf(selectedTimePeriod);
        const currentEndDate = dayjs().utc().endOf(selectedTimePeriod);

        setSdate(currentStartDate.format("YYYY-MM-DD"));
        setEdate(currentEndDate.format("YYYY-MM-DD"));
        // GetAllemployee();
      }
    };
    initialRender();
    //}
  }, [selectedTimePeriod]);

  useEffect(() => {
    if (selectedType === 6) {
      const initialRender = async () => {
        await getAllClients();
        await getAllProjects("All");
        GetAllemployee();
      };
      setSelectedClient("All");
      setSelectedProject("All");
      setSelectedTimePeriod("year");
      initialRender();
    }
  }, [selectedType]);

  useEffect(() => {
    if (sDate && eDate) {
      getAllApiData(selectedClient || "All");
      //console.log("called inside")
    }
    //console.log("called outside")
    //console.log('setClientChanged', sDate, eDate)
  }, [sDate, eDate]);

  useEffect(() => {
    const initialRender = async () => {
      await getAllClients();
      await getAllProjects("All");
      GetAllemployee();
    };
    setSelectedClient("All");
    setSelectedProject("All");
    setSelectedTimePeriod("week");
    handleWeekSelection([today]);
    initialRender();
  }, []);

  useEffect(() => {
    if (selectedClient) {
      // Fetch projects for the selected client
      getAllProjects(selectedClient);
      setSelectedProject("All");
      setSelectedProjectName(null);
      // setSelectedTimePeriod("week")
    }
  }, [selectedClient]);

  useEffect(() => {
    const transformData = async (
      rawData,
      selectedClient,
      selectedProject,
      selectedType,
      selectedEmployee,
      selectedTask
    ) => {
      const filteredData = rawData
        .filter((project) => {
          if (selectedClient === "All" && selectedProject === "All")
            return true;
          if (selectedClient !== "All" && selectedProject === "All")
            return project.Client_id == selectedClient;
          return (
            project.Client_id == selectedClient &&
            project.Project_id == selectedProject
          );
        })
        .flatMap((project) =>
          project.Tasks.filter((task) => {
            // Filter by employee
            if (selectedEmployee !== 1 && task.Emp_id != selectedEmployee)
              return false;
            // Filter by task
            if (
              selectedTask &&
              selectedTask !== "All" &&
              task.ItemId != selectedTask
            )
              return false;
            return true;
          }).flatMap((task) => {
            const comments = task.Task_comments || [];
            return comments.map((comment) => ({
              client_id: task.Client_id,
              client_name: task.Client_name,
              project_id: project.Project_id,
              project_name: project.Project_name,
              employee_id: task.Emp_id,
              employee_name: task.Employee_id,
              task_id: task.ItemId,
              task_name: task.ItemName,
              comments_data: comment.content,
              comments_id: comment.CommentId,
              comments_Date: comment.comments_Date,
              Hours: timeToFloatHours(comment.Comment_hrs),
              Billing_Status : task.Billing_Status,
            }));
          })
        );

      console.log("filtered data", filteredData);
      if (selectedType === 1) {
        const formattedData = filteredData.map((row) => ({
          ...row,
          Hours: parseFloat(row.Hours).toFixed(2),
        }));
        return formattedData;
      }

      if (selectedType === 3) {
        const groupedProjects = filteredData.reduce((acc, item) => {
          const {
            project_id,
            project_name,
            client_id,
            client_name,
            comments_id,
            comments_data,
            employee_name,
            Hours,
            comments_Date,
          } = item;

          if (!acc[project_id]) {
            acc[project_id] = {
              Project_id: project_id,
              project: project_name,
              Client_name: client_name,
              Hours: 0,
              comments: [],
            };
          }

          acc[project_id].Hours += Number(Hours) || 0;

          acc[project_id].comments.push({
            CommentId: comments_id,
            content: comments_data,
            comments_Date: comments_Date || "N/A",
            Comment_hrs: Number(Hours) || 0,
            Employee: employee_name,
          });

          return acc;
        }, {});

        return Object.values(groupedProjects)
          .sort((a, b) => b.Hours - a.Hours)
          .map((project) => ({
            project: project.project,
            employee: "",
            comment: "",
            Hours: project.Hours.toFixed(2),
            comments: project.comments
              .sort((a, b) => b.Comment_hrs - a.Comment_hrs)
              .map((comment) => ({
                CommentId: comment.CommentId,
                content: comment.content,
                comments_Date: comment.comments_Date,
                Comment_hrs: comment.Comment_hrs.toFixed(2),
                Employee: comment.Employee,
              })),
          }));
      }

      if (selectedType === 4) {
        const employeeMap = {};

        filteredData.forEach((item) => {
          const {
            employee_name,
            project_id,
            project_name,
            Hours,
            comments_data,
            comments_Date,
          } = item;
          const hoursNum = Number(Hours) || 0;
          const commentsArray =
            comments_data && comments_data.trim() !== ""
              ? comments_data.split("; ").map((comment) => comment.trim())
              : [];

          const baseHours = hoursNum / (commentsArray.length || 1);

          commentsArray.forEach((comment, index) => {
            if (!employeeMap[employee_name]) {
              employeeMap[employee_name] = {
                employee_name,
                Hours: 0,
                subRows: [],
                projectGroups: {},
              };
            }

            if (!employeeMap[employee_name].projectGroups[project_id]) {
              employeeMap[employee_name].projectGroups[project_id] = {
                project_id,
                project_name,
                comments: [],
              };
            }

            employeeMap[employee_name].projectGroups[project_id].comments.push({
              comment: comment || "No comment",
              comments_Date: comments_Date || "N/A", // Use actual date or fallback
              Hours: baseHours.toFixed(2),
            });
            employeeMap[employee_name].Hours += baseHours;
          });
        });

        const transformed = Object.values(employeeMap)
          .map((employee) => {
            const subRows = [];
            Object.values(employee.projectGroups).forEach((group) => {
              group.comments.forEach((comment) => {
                subRows.push({
                  project_id: group.project_id,
                  project_name: group.project_name,
                  comment: comment.comment,
                  comments_Date: comment.comments_Date,
                  Hours: comment.Hours,
                  isCommentRow: true,
                });
              });
            });

            return {
              employee_name: employee.employee_name,
              Hours: employee.Hours.toFixed(2),
              subRows: subRows.sort((a, b) => {
                if (a.project_id === b.project_id) {
                  if (a.isProjectRow && !b.isProjectRow) return -1;
                  if (!a.isProjectRow && b.isProjectRow) return 1;
                  return (a.comment || "").localeCompare(b.comment || "");
                }
                return (b.project_name || "").localeCompare(
                  a.project_name || ""
                );
              }),
            };
          })
          .sort((a, b) => Number(b.Hours) - Number(a.Hours));

        return transformed;
      }

      if (selectedType === 5) {
        const groupedProjects = filteredData.reduce((acc, item) => {
          const {
            project_id,
            project_name,
            client_id,
            client_name,
            task_id,
            task_name,
            comments_id,
            comments_data,
            employee_name,
            Hours,
          } = item;

          if (!acc[project_id]) {
            acc[project_id] = {
              Project_id: project_id,
              project: project_name,
              Client_name: client_name,
              employee: employee_name, // Set employee at project level (optional, can be removed if only needed in comments)
              Hours: 0,
              tasks: {},
            };
          }

          acc[project_id].Hours += Number(Hours) || 0;

          if (!acc[project_id].tasks[task_id]) {
            acc[project_id].tasks[task_id] = {
              ItemId: task_id,
              task: task_name,
              Status: "In Progress", // Placeholder
              Priority: "High", // Placeholder
              TaskHours: 0,
              comments: [],
            };
          }

          acc[project_id].tasks[task_id].TaskHours += Number(Hours) || 0;

          acc[project_id].tasks[task_id].comments.push({
            CommentId: comments_id,
            content: comments_data,
            comments_Date: "31-05-2025", // Use actual date if available
            Comment_hrs: Number(Hours) || 0,
            Employee: employee_name, // Ensure Employee is included in comments
          });

          return acc;
        }, {});

        // Sort projects by Hours descending, then map and format
        return Object.values(groupedProjects)
          .sort((a, b) => b.Hours - a.Hours) // Sort projects descending by Hours
          .map((project) => ({
            project: project.project,
            task: "", // Empty for top-level row
            employee: "", // Empty for top-level row (employee shown in DetailPanel)
            comment: "", // Empty for top-level row
            Hours: project.Hours.toFixed(2),
            tasks: Object.values(project.tasks)
              .sort((a, b) => b.TaskHours - a.TaskHours) // Sort tasks descending by TaskHours
              .map((task) => ({
                task: task.task,
                TaskHours: task.TaskHours.toFixed(2),
                comments: task.comments
                  .sort((a, b) => b.Comment_hrs - a.Comment_hrs) // Sort comments descending by Comment_hrs
                  .map((comment) => ({
                    CommentId: comment.CommentId,
                    content: comment.content,
                    comments_Date: comment.comments_Date,
                    Comment_hrs: comment.Comment_hrs.toFixed(2),
                    Employee: comment.Employee,
                  })),
              })),
          }));
      }

      if (selectedType === 6) {
        const clientMap = {};
        const now = dayjs();
        const startOfWeek = now.startOf("isoWeek");
        const startOfLastWeek = startOfWeek.subtract(1, "week");
        const endOfLastWeek = startOfWeek.subtract(1, "day");
        const startOfMonth = now.startOf("month");
        const startOfYear = now.startOf("year");
        //console.log("yEAR", startOfYear)

        filteredData.forEach((item) => {
          const {
            client_name,
            project_id,
            project_name,
            Hours,
            comments_Date,
          } = item;

          const hoursNum = Number(Hours) || 0;
          const entryDate = dayjs(comments_Date, "DD-MM-YYYY");
          //console.log('entryDate', entryDate.format('YYYY-MM-DD'));
          if (!clientMap[client_name]) {
            clientMap[client_name] = {
              client_name,
              Hours: 0,
              WeekHours: 0,
              pastweek: 0,
              MonthHours: 0,
              YearyHours: 0,
              subRows: [],
              projectGroups: {},
            };
          }

          if (!clientMap[client_name].projectGroups[project_id]) {
            clientMap[client_name].projectGroups[project_id] = {
              project_id,
              project_name,
              Hours: 0,
              WeekHours: 0,
              pastweek: 0,
              MonthHours: 0,
              YearyHours: 0,
            };
          }

          // Add hours to project group

          clientMap[client_name].projectGroups[project_id].Hours += hoursNum;
          clientMap[client_name].Hours += hoursNum;

          // Add by time ranges
          if (entryDate.isSameOrAfter(startOfWeek)) {
            clientMap[client_name].projectGroups[project_id].WeekHours +=
              hoursNum;
            clientMap[client_name].WeekHours += hoursNum;
          }
          if (
            entryDate.isSameOrAfter(startOfLastWeek) &&
            entryDate.isSameOrBefore(endOfLastWeek)
          ) {
            clientMap[client_name].projectGroups[project_id].pastweek +=
              hoursNum;
            clientMap[client_name].pastweek += hoursNum;
          }

          if (entryDate.isSameOrAfter(startOfMonth)) {
            clientMap[client_name].projectGroups[project_id].MonthHours +=
              hoursNum;
            clientMap[client_name].MonthHours += hoursNum;
          }

          if (entryDate.isSameOrAfter(startOfYear)) {
            clientMap[client_name].projectGroups[project_id].YearyHours +=
              hoursNum;
            clientMap[client_name].YearyHours += hoursNum;
          }
        });

        const result = Object.values(clientMap).map((client) => {
          const subRows = Object.values(client.projectGroups).map(
            (project) => ({
              project_name: project.project_name,
              project_id: project.project_id,
              Hours: project.Hours.toFixed(2),
              WeekHours: project.WeekHours.toFixed(2),
              pastweek: project.pastweek.toFixed(2),
              MonthHours: project.MonthHours.toFixed(2),
              YearyHours: project.YearyHours.toFixed(2),
            })
          );

          return {
            client_name: client.client_name,
            Hours: client.Hours.toFixed(2),
            WeekHours: client.WeekHours.toFixed(2),
            pastweek: client.pastweek.toFixed(2),
            MonthHours: client.MonthHours.toFixed(2),
            YearyHours: client.YearyHours.toFixed(2),
            subRows,
          };
        });

        return result.sort((a, b) => Number(b.Hours) - Number(a.Hours));
      }

      let groupByKey;
      let nameKey;

      switch (selectedType) {
        case 2:
          groupByKey = "client_id";
          nameKey = "client_name";
          break;
        case 3:
          groupByKey = "project_id";
          nameKey = "project_name";
          break;
        case 5:
          groupByKey = "task_id";
          nameKey = "task_name";
          break;
        default:
          return filteredData;
      }

      const grouped = filteredData.reduce((acc, item) => {
        const key = item[groupByKey];
        if (!acc[key]) {
          acc[key] = {
            [groupByKey]: key,
            [nameKey]: item[nameKey],
            Hours: 0,
          };
        }
        acc[key].Hours += Number(item.Hours) || 0;
        return acc;
      }, {});

      // Format Hours and then sort by Hours descending
      const result = Object.values(grouped)
        .map((group) => ({
          ...group,
          Hours: group.Hours.toFixed(2),
        }))
        .sort((a, b) => b.Hours - a.Hours); // sort by numeric Hours descending

      return result;
    };

    const fetchAndSetData = async () => {
      if (selectedClient && selectedProject && rawData && selectedType) {
        console.log("Inputs:", {
          selectedClient,
          selectedProject,
          rawData,
          selectedType,
          selectedTask,
        });
        const result = await transformData(
          rawData,
          selectedClient,
          selectedProject,
          selectedType,
          selectedEmployee,
          selectedTask
        );
        let temp = 0;
        result.forEach((item) => {
          temp += parseFloat(item.Hours) || 0;
        });
        console.log("Transformed Data", result);
        setProjectData(result);
        setTotalHours(temp);
      }
    };

    fetchAndSetData();
    //console.log("rawData", rawData)
  }, [
    selectedClient,
    selectedProject,
    rawData,
    selectedType,
    selectedEmployee,
    selectedTask,
  ]);

  // Blue client-hours boxes for the "Project Hrs Report" tab, styled the same
  // way as the project cards on the Activity Card page (Timesheet.js).
  // const clientHourCards = useMemo(() => {
  //   if (!clientWiseTHrs) return [];
  //   const cardColor = { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' };

  //   return Object.values(clientWiseTHrs).map((client) => {
  //     //worked hours
  //     const whours = Math.floor(client.minutes / 60);
  //     const wmins = client.minutes % 60;
  //     const wformatted = `${whours}:${String(wmins).padStart(2, '0')}`;

  //     //estimated hours
  //     const eformatted = `${client.plannedHours}:00`;
      
  //     return { name: client.name, Workedhours: wformatted, color: cardColor, estimatedhours: eformatted };
  //   });
  // }, [clientWiseTHrs]);

  const clientHourCards = useMemo(() => {
    if (!clientWiseTHrs) return [];

    return Object.values(clientWiseTHrs).map((client) => {
      // Worked hours
      const whours = Math.floor(client.minutes / 60);
      const wmins = client.minutes % 60;
      const wformatted = `${whours}:${String(wmins).padStart(2, '0')}`;

      // Estimated hours
      const estimatedMinutes = Number(client.plannedHours || 0) * 60;
      const workedMinutes = Number(client.minutes || 0);

      const eformatted = `${client.plannedHours}:00`;

      // Color logic
      let cardColor;

      if (workedMinutes <= estimatedMinutes) {
        // Within estimate
        cardColor = {
          border: '#22c55e',
          text: '#15803d',
          bg: '#f0fdf4'
        };
      } else if (workedMinutes <= estimatedMinutes + 60) {
        // Over estimate by up to 1 hour
        cardColor = {
          border: '#f59e0b',
          text: '#b45309',
          bg: '#fffbeb'
        };
      } else {
        // Over estimate by more than 1 hour
        cardColor = {
          border: '#ef4444',
          text: '#b91c1c',
          bg: '#fef2f2'
        };
      }

      cardColor = { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' };

      return {
        name: client.name,
        Workedhours: wformatted,
        color: cardColor,
        estimatedhours: eformatted
      };
    });
  }, [clientWiseTHrs]);


  const tableRef = useRef(null);

  useEffect(() => {
    if (tableRef.current) {
      const allRows = tableRef.current.getRowModel().rows;
      // console.log("Table rows:", allRows);
    }
  }, [tableRef.current, totalHours]);

  useEffect(() => {
    if (selectedTimePeriod === "week") {
      const weekDates = async () => {
        await handleWeekSelection([today]);
        console.log("ENTERED WEEK", handleWeekSelection([today]));
      };
      weekDates();
    }
  }, [selectedTimePeriod]);

  useEffect(() => {
    setSelectedClient("All");
    setSelectedProject("All");
    setSelectedEmployee(1);
  }, [selectedType]);

  // const billingPercentage = summaryHours.working
  //   ? (
  //       ((summaryHours.working - summaryHours.billing) / summaryHours.working) *
  //       100
  //     ).toFixed(2) + "%"
  //   : "0.00%";
  // const nonBillingPercentage = summaryHours.working
  //   ? (
  //       ((summaryHours.working - summaryHours.nonBilling) /
  //         summaryHours.working) *
  //       100
  //     ).toFixed(2) + "%"
  //   : "0.00%";
  // const totalPercentage = summaryHours.working
  //   ? (
  //       ((summaryHours.working - summaryHours.total) / summaryHours.working) *
  //       100
  //     ).toFixed(2) + "%"
  //   : "0.00%";

  return (
    <>
      {contextHolder}
      <section className="reports-section">
        {/* <div className="flex flex-wrap items-center justify-between gap-3 mt-[35px] pr-[0px]">
          <div>
            <h2 className="page-heading relative">Activity Card</h2>
          </div>
          <Button
            className="bg-[#3b82f6] text-[#fff] h-[28px] w-[110px]"
            style={{
              paddingInline: "8px 10px",
              display: loading ? "none" : "block",
            }}
            onClick={handleExportVisibleData}
          >
            <FileDownloadIcon style={{ fontSize: "18px" }} /> Export
          </Button>
        </div> */}
        {/* Activity Card New design start */}
        <div className="flex flex-wrap items-center justify-between gap-3 mt-[35px] pr-[0px]">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-[38px] h-[38px] rounded-lg bg-[#eff6ff]">
              <BarChartIcon
                style={{
                  fontSize: "24px",
                  color: "#2563eb",
                }}
              />
            </div>

            <div>
              <h2 className="text-[22px] font-semibold text-[#17365D] leading-[26px]">
                Activity Card
              </h2>

              {/* <p className="text-[13px] text-[#64748B] mt-[3px]">
                Total Hours vs Utilized Hours
              </p> */}
            </div>
          </div>

          <Button
            className="bg-[#3b82f6] text-[#fff] h-[32px] w-[110px]"
            style={{
              paddingInline: "8px 10px",
              display: loading ? "none" : "block",
              borderRadius: "6px",
              textTransform: "none",
            }}
            onClick={handleExportVisibleData}
          >
            <FileDownloadIcon style={{ fontSize: "18px", marginRight: "5px" }} />
            Export
          </Button>
        </div>
        {/* Activity Card New design end */}

        {/* Client-wise hours boxes */}
        {!loading && clientHourCards.length > 0 && (
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            marginTop: '15px',
            marginBottom: '15px',
          }}>
            {clientHourCards.map((card, idx) => (
              <div
                key={idx}
                style={{
                  border: `2px solid ${card.color.border}`,
                  borderRadius: '8px',
                  backgroundColor: card.color.bg,
                  padding: '5px',
                  width: '180px',
                  display: 'flex',
                  gap: '5px',
                  flexDirection: 'row',
                  alignItems: 'baseline',
                  justifyContent: 'center',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                }}
              >
                <span style={{
                  fontSize: '11px',
                  fontWeight: '600',
                  color: '#555',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  // maxWidth: '130px',
                }} title={card.name}>
                  {card.name}
                </span>
                {/* <span style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: card.color.text,
                }}>
                  {card.estimatedhours}
                </span> */}
                <span style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: card.color.text,
                }}>
                  {card.Workedhours}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* {!loading && clientHourCards.length > 0 && (
          <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              gap: '10px',
              marginTop: '15px',
              marginBottom: '15px',
              overflowX: 'auto',
              overflowY: 'hidden',
              width: '100%',
              paddingBottom: '8px',
            }}
          >
            {clientHourCards.map((card, idx) => (
              <div
                key={idx}
                style={{
                  border: `2px solid ${card.color.border}`,
                  borderRadius: '8px',
                  backgroundColor: card.color.bg,
                  padding: '10px 15px',
                  minWidth: '180px',
                  flex: '0 0 auto',
                  color: card.color.text,
                }}
              >
                // Client Name
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#17365D",
                    marginBottom: "14px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={card.name}
                >
                  {card.name}
                </div>

                // Hours Section 
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  // Total Hours
                  <div
                    style={{
                      flex: 1,
                      textAlign: "left",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#64748B",
                        marginBottom: "3px",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Total Hours
                    </div>

                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: card.color.text,
                        lineHeight: "24px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {card.estimatedhours}
                    </div>
                  </div>

                  // Divider
                  <div
                    style={{
                      width: "1px",
                      height: "38px",
                      backgroundColor: "#CBD5E1",
                      margin: "0 15px",
                    }}
                  />

                  // Utilized Hours
                  <div
                    style={{
                      flex: 1,
                      textAlign: "left",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#64748B",
                        marginBottom: "3px",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Utilized Hours
                    </div>

                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: card.color.text,
                        lineHeight: "24px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {card.Workedhours}y
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )} */}

        {/* {!loading && (
          <div className="text-right mt-[25px] mb-[-40px]">
            <span className="text-[13px] font-[600] text-[#555]">
              Total Hours :{" "}
            </span>
            <span className="text-[13px] font-[600] text-[#555]">
              {(totalHours || 0).toFixed(2)}
            </span>
          </div>
        )} */}

        <div style={{ marginTop: "20px", marginBottom: "-10px" }}>
          {selectedEmployee !== 1 && selectedProject === "All" && !loading && (
            <div className="flex flex-wrap gap-4 pt-3 mb-0">
              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex items-center justify-between">
                <label className="text-[13px] font-[600] text-[#555]">
                  Available Hours :{" "}
                  <span className="text-[14px] font-bold text-blue-600">
                    {summaryHours.working}
                  </span>
                </label>
              </div>
              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex flex-col justify-between">
                <div className="text-[13px] font-[600] text-[#555] mt-[7.5px]">
                  Billing Hours :{" "}
                  <span
                    className={`text-[14px] font-bold ${
                      summaryHours?.empbillingPercentage?.startsWith("-")
                        ? "text-red-600"
                        : "text-green-600"
                    }`}
                  >
                    {summaryHours.billing}
                  </span>
                </div>
                <div
                  className={`text-[10px] font-bold text-right ${
                    summaryHours?.empbillingPercentage?.startsWith("-")
                      ? "text-red-600"
                      : "text-green-600"
                  }`}
                >
                  {summaryHours?.empbillingPercentage}
                </div>
              </div>
              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex flex-col justify-between">
                <div className="text-[13px] font-[600] text-[#555] mt-[7.5px]">
                  Non-Billing Hours :{" "}
                  <span
                    className={`text-[14px] font-bold ${
                      summaryHours?.empnonBillingPercentage?.startsWith("-")
                        ? "text-red-600"
                        : "text-green-600"
                    }`}
                  >
                    {summaryHours.nonBilling}
                  </span>
                </div>
                <div
                  className={`text-[10px] font-bold text-right ${
                    summaryHours?.empnonBillingPercentage?.startsWith("-")
                      ? "text-red-600"
                      : "text-green-600"
                  }`}
                >
                  {summaryHours?.empnonBillingPercentage}
                </div>
              </div>
              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex flex-col justify-between">
                <div className="text-[13px] font-[600] text-[#555] mt-[7.5px] ">
                  Total Hours iiiiiiiiiiii:{" "}
                  <span
                    className={`text-[14px] font-bold ${
                      summaryHours?.emptotalPercentage?.startsWith("-")
                        ? "text-red-600"
                        : "text-gray-600"
                    }`}
                  >
                    {summaryHours.total}
                  </span>
                </div>
                <div
                  className={`text-[10px] font-bold text-right ${
                    summaryHours?.emptotalPercentage?.startsWith("-")
                      ? "text-red-600"
                      : "text-gray-600"
                  }`}
                >
                  {summaryHours?.emptotalPercentage}
                </div>
              </div>

              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex items-center justify-between">
                <label className="text-[13px] font-[600] text-[#555]">
                  Leave Hours :{" "}
                  <span className="text-[14px] font-bold text-blue-600">
                    {offHours}
                  </span>
                </label>
              </div>
            </div>
          )}

          {selectedProject !== "All" && !loading && (
            <div className="flex flex-wrap gap-4 pt-3 mb-0">
              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex items-center justify-between">
                <label className="text-[13px] font-[600] text-[#555]">
                  Project Hours :{" "}
                  <span className="text-[14px] font-bold text-blue-600">
                    {projectSummary.estimatedHours}
                  </span>
                </label>
              </div>
              <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex flex-col justify-between">
                <div className="text-[13px] font-[600] text-[#555] mt-[7.5px]">
                  Billing Hours :{" "}
                  <span
                    className={`text-[14px] font-bold ${
                      projectSummary.billingPercentage.startsWith("-")
                        ? "text-red-600"
                        : "text-green-600"
                    }`}
                  >
                    {projectSummary.billingHours}
                  </span>
                </div>
                <div
                  className={`text-[10px] font-bold text-right ${
                    projectSummary.billingPercentage.startsWith("-")
                      ? "text-red-600"
                      : "text-green-600"
                  }`}
                >
                  {projectSummary.billingPercentage}
                </div>
              </div>

            <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex flex-col justify-between">
              <div className="text-[13px] font-[600] text-[#555] mt-[7.5px]">
                Non-Billing Hours :{" "}
                <span
                  className={`text-[14px] font-bold ${
                    projectSummary.nonBillingPercentage.startsWith("-")
                      ? "text-red-600"
                      : "text-green-600"
                  }`}
                >
                  {projectSummary.nonBillingHours}
                </span>
              </div>
              <div
                className={`text-[10px] font-bold text-right ${
                  projectSummary.nonBillingPercentage.startsWith("-")
                    ? "text-red-600"
                    : "text-green-600"
                }`}
              >
                {projectSummary.nonBillingPercentage}
              </div>
            </div>

            <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex flex-col justify-between">
              <div className="text-[13px] font-[600] text-[#555] mt-[7.5px] mx-3">
                Total Hours :{" "}
                <span
                  className={`text-[14px  ] font-bold ${
                    projectSummary.totalPercentage.startsWith("-")
                      ? "text-red-600"
                      : "text-gray-600"
                  }`}
                >
                  {projectSummary.totalHours}
                </span>
              </div>
              <div
                className={`text-[10px] font-bold text-right ${
                  projectSummary.totalPercentage.startsWith("-")
                    ? "text-red-600"
                    : "text-gray-600"
                }`}
              >
                {projectSummary.totalPercentage}
              </div>
            </div>

            <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex items-center justify-between">
            <label className="text-[13px] font-[600] text-[#555]">
              Allocated Hours :{" "}
              <span className="text-[14px] font-bold text-blue-600">
                {projectSummary.estimatedHours}
              </span>
            </label>
            </div>

            <div className="border border-gray-300 rounded p-3 bg-white shadow-md w-55 h-16 flex items-center justify-between">
              <label className="text-[13px] font-[600] text-[#555]">
                Tracked Hours :{" "}
                <span className="text-[14px] font-bold text-blue-600">
                  {projectSummary.totalHours}
                </span>
              </label>
            </div>
            </div>
          )}
        </div>

        <div className="flex justify-start items-center gap-[10px] relative z-[99] left-[10px] top-[38px] h-[70px] m-0">
          <div className="flex justify-start gap-[10px]">
            <div className="flex flex-col gap-[5px]">
              <label className="text-[13px] pl-2">Clients:</label>
              <Select
                style={{ width: 150 }}
                placeholder="Select Client"
                value={selectedClient}
                showSearch
                optionFilterProp="label"
                onChange={(e) => setSelectedClient(e)}
                disabled={loading}
                options={allClientList || []}
              />
            </div>

            <div className="flex flex-col gap-[5px]">
              <label className="text-[13px] pl-2">Projects:</label>
              <Select
                className="w-[180px] custom-project-select"
                disabled={loading || projectDisabled || selectedType === 2}
                placeholder={projectDisabled ? "No Projects" : "Select Project"}
                value={selectedProject}
                showSearch
                optionFilterProp="label"
                onChange={handleProjectChange}
                options={
                  selectedClient === "All"
                    ? [
                        {
                          label: "All",
                          value: "All",
                        },
                      ]
                    : projectList[selectedClient]
                    ? [
                        {
                          label: "All",
                          value: "All",
                        },
                        ...projectList[selectedClient]
                          .map((project) => ({
                            value: project.projectId,
                            label: project.projectName,
                          })),
                      ]
                    : []
                }
              />
            </div>
            {/* Task Filter */}

            {/* <div className="flex flex-col gap-[5px]">
              <label className="text-[13px] pl-2">Task:</label>
              <Select
                style={{ width: 150 }}
                disabled={loading || taskDisabled || selectedType === 2}
                placeholder={taskDisabled ? "No Tasks" : "Select Task"}
                value={selectedTask}
                showSearch
                optionFilterProp="label"
                onChange={handleTaskChange}
                options={
                  selectedProject === "All"
                    ? [
                        {
                          label: "All",
                          value: "All",
                        },
                      ]
                    : TaskList[selectedProject]
                    ? [
                        {
                          label: "All",
                          value: "All",
                        },
                        ...TaskList[selectedProject].map((task) => ({
                          value: task.ItemId,
                          label: task.ItemName,
                        })),
                      ]
                    : []
                }
              />
            </div> */}

            {/* <div className="flex flex-col gap-[5px]">
              <label className="text-[13px] pl-2">Task:</label>
              <Select
                style={{ width: 150 }}
                placeholder="Select task"
                value={selectedTask}
                showSearch
                optionFilterProp="label"
                onChange={(e) => setSelectedTask(e)}
                disabled={loading}
                options={TaskList}
                // options={
                //    selectedProject === "All"
                //     ? [
                //         {
                //           label: "All",
                //           value: "All",
                //         },
                //       ]
                //     : TaskList[selectedProject]
                //     ? [
                //         {TaskList}
                //     ]
                // }
              />
            </div> */}
          </div>

          <div className="flex justify-start gap-[10px]">
            <div className="flex flex-col gap-[5px]">
              <label className="text-[13px] pl-2">Employee:</label>
              <Select
                style={{ width: 170 }}
                placeholder="Select employee"
                value={selectedEmployee}
                showSearch
                optionFilterProp="label"
                // defaultValue={1}
                onChange={(e) => setSelectedEmployee(e)}
                disabled={loading}
                options={Employee}
              />
            </div>
          </div>
          <div className="flex justify-start gap-[10px]">
            {/* <div className="flex flex-col gap-[5px]">
              <label className="text-[13px] pl-2">Types:</label>
              <Select
                style={{ width: 155 }}
                placeholder="Select Type"
                value={selectedType}
                showSearch
                optionFilterProp="label"
                defaultValue={1}
                onChange={(e) => setSelectedType(e)}
                disabled={loading}
                options={[
                  { label: "All Data", value: 1 },
                  { label: "Client Report", value: 2 },
                  { label: "Project Report", value: 3 },
                  { label: "Employee Report", value: 4 },
                  { label: "High Hrs Tasks", value: 5 },
                  { label: "Project Hrs Report", value: 6 },
                ]}
              />
            </div> */}
            {[1, 2, 3, 4, 5].includes(selectedType) && (
              <div className="flex flex-col gap-[5px]">
                <label className="text-[13px] pl-2">Time Periods:</label>
                <Select
                  style={{ width: 140 }}
                  placeholder="Time Period"
                  value={selectedTimePeriod}
                  options={options}
                  onChange={handleTimePeriodChange}
                  disabled={loading}
                />
              </div>
            )}
            <div style={{ left: "100px" }}>
              <div className="flex flex-col gap-[5px]">
                <label className="text-[13px] pl-2">Date:</label>

                {selectedTimePeriod === "month" && (
                  <RangePicker
                    className="max-w-[225px]"
                    allowClear={false}
                    defaultValue={[
                      dayjs().startOf("month"),
                      dayjs().endOf("month"),
                    ]}
                    picker="month"
                    placeholder={["Start Month", "End Month"]}
                    format="MMMM YYYY"
                    onChange={handleDateChange}
                    disabled={loading}
                    disabledDate={(current) => {
                      // Disable future months

                      return current && current > dayjs().endOf("month");
                    }}
                  />
                )}

                {selectedTimePeriod === "year" && (
                  <RangePicker
                    className="max-w-[200px]"
                    allowClear={false}
                    defaultValue={[
                      dayjs().startOf("year"),
                      dayjs().endOf("year"),
                    ]}
                    picker="year"
                    placeholder={["Start Year", "End Year"]}
                    format="YYYY"
                    onChange={handleDateChange}
                    disabled={loading}
                    disabledDate={(current) => {
                      // Disable future years

                      return current && current.year() > dayjs().year();
                    }}
                  />
                )}

                {selectedTimePeriod === "day" && (
                  <RangePicker
                    className="max-w-[225px]"
                    allowClear={false}
                    defaultValue={[
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ]} // should be [dayjs(), dayjs()] or null
                    placeholder={["Start Date", "End Date"]}
                    format="DD-MM-YYYY"
                    onChange={handleDateChange}
                    disabled={loading}
                    disabledDate={(current) => {
                      // Disable future dates

                      return current && current > dayjs().endOf("day");
                    }}
                  />
                )}

                {selectedTimePeriod === "week" && (
                  <Flatpickr
                    className={`ant-select ant-select-outlined max-w-[200px] date-picker-client-report ${
                      loading
                        ? "date-picker-client-report-disabled"
                        : "date-picker-client-report"
                    }`}
                    value={selectedWeekDates}
                    options={{
                      mode: "range",
                      dateFormat: "D, M j",

                      onChange: (selectedDates, DaysDate, instance) => {
                        handleWeekSelection(selectedDates, instance);
                      },

                      disable: [
                        function (date) {
                          const week_selectedDate = today;

                          const week_startOfWeek = new Date(week_selectedDate);

                          const week_dayOfWeek = week_startOfWeek.getDay();

                          const daysToMonday =
                            week_dayOfWeek == 0 ? 6 : week_dayOfWeek - 1;

                          week_startOfWeek.setDate(
                            week_startOfWeek.getDate() - daysToMonday
                          );

                          const week_endOfWeek = new Date(week_startOfWeek);

                          week_endOfWeek.setDate(
                            week_startOfWeek.getDate() + 6
                          );

                          //console.log(week_dayOfWeek, date, "week_endOfWeek")

                          return date > week_endOfWeek;
                        },
                      ],

                      //
                    }}
                    noCalendar={loading}
                    placeholder="Select Week"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex justify-end items-center gap-[10px]">
          <label className="text-[13px] font-[600] text-[#555] relative z-[99] left-[-10px] top-[35px] project-hrs">Total Hours : 2342342344</label>
        </div> */}

        <div className="mt-[-40px] custom-table custom-project-table">
          {loading ? (
            <Spin
              tip="Loading..."
              className="justify-center items-center flex"
              style={{ height: "100vh" }}
            >
              <CustomTable
                columns={columns}
                data={[]}
                component="Project Report"
                handleExportData={() =>
                  handleExportData(
                    projectData,
                    sDate,
                    eDate,
                    selectedTimePeriod
                  )
                }
                hours={totalHours}
              />
            </Spin>
          ) : (
            <CustomTable
              columns={columns}
              data={[...projectData]}
              component={"Project Report"}
              handleExportData={handleExportData}
              hours={totalHours}
              onTableInstance={(instance) => {
                tableRef.current = instance;
              }}
              // setTotalHours={setTotalHours}
              setOffHours={setOffHours}
              FormatTime={formatTime}
              sidebor={sidebor}
              key={selectedType}
              selectedType={selectedType}
            />
          )}
        </div>
      </section>
    </>
  );
}
